<template>
  <div class="quick-order">
    <Spin size="large" fix v-if="spinShow"></Spin>

    <form autocomplete="off">
      <div
        class="common-rowUnder"
        @scroll="handleScroll"
        :style="{
          height: 'calc(100vh - 60px)',
          overflowY: 'auto',
          background: '#fff',
        }"
      >
        <!-- {{categoryMessage.id}} -->
        <!-- 顶部步骤条 -->
        <div class="quick-order-step">
          <div class="common-flex" style="width: 1420px; margin: 0 auto">
            <div class="new-order-select">
              <Select
                v-model="productId"
                @on-change="changeProduct"
                placeholder=" "
                prefix="ios-shirt"
                style="width: 120px"
                filterable
              >
                <Option
                  v-for="item in product"
                  :value="item.id"
                  :key="item.id"
                >{{ item.name }}
                </Option
                >
              </Select>
            </div>
            <div class="common-flex">
              <div
                class="common-flex step-item common-align-center"
                v-for="(item, index) in stepList"
                :key="index"
              >
                <div class="step-item-name common-hover">
                  <!-- @click="changeStep(item)" -->
                  {{ item.name }}
                  <div
                    v-if="stepId == item.step"
                    class="step-item-choose"
                  ></div>
                </div>
                <Icon style="margin: 0 33px 0 39px" type="ios-arrow-forward"/>
              </div>
            </div>
            <div
              class="common-flex step-item"
              v-if="orderCode"
              style="margin-left: auto"
            >
              No.{{ this.orderCode }}
            </div>
          </div>
        </div>
        <!-- 内容部分 步骤一 -->
        <div v-if="stepId == 1" class="common-flex quick-order-details">
          <!-- 用户信息或者工艺品类 -->
          <div class="quick-order-l common-rowUnder">
            <!-- 用户信息 -->
            <div class="order-l-item common-flex common-align-center">
              <div class="order-l-item-label">Name</div>
              <AutoComplete
                class="order-l-item-ipt"
                v-model="submitOrder.customerName"
                @on-select="changeCus"
                @on-search="handleSearch"
                style="width: 200px"
                clearable
              >
                <Option
                  v-for="item in customer"
                  :value="item.custName"
                  :key="item.id"
                >{{ item.custName }}
                </Option
                >
              </AutoComplete>
              <!-- <Input class="order-l-item-ipt" type="text" v-model="submitOrder.customerName" placeholder="" /> -->
            </div>
            <div
              class="order-l-item common-flex common-align-center common-justify-between"
            >
              <div class="common-flex common-align-center">
                <div class="order-l-item-label">Height</div>
                <Input
                  class="order-l-item-ipt"
                  type="text"
                  v-model="submitOrder.height"
                  placeholder=""
                />
              </div>
              <Select
                @on-change="changeHeight"
                label-in-value
                v-model="submitOrder.heightUnit"
                style="width: 70px"
              >
                <Option
                  v-for="item in heightList"
                  :value="item.id"
                  :key="item.id"
                >{{ item.name }}
                </Option
                >
              </Select>
            </div>
            <div
              class="order-l-item common-flex common-align-center common-justify-between"
            >
              <div class="common-flex common-align-center">
                <div class="order-l-item-label">Weight</div>
                <Input
                  class="order-l-item-ipt"
                  type="text"
                  v-model="submitOrder.weight"
                  placeholder=""
                />
              </div>
              <Select v-model="submitOrder.weightUnit" style="width: 70px">
                <Option
                  v-for="item in weightList"
                  :value="item.id"
                  :key="item.id"
                >{{ item.name }}
                </Option
                >
              </Select>
            </div>
            <div
              class="order-l-item common-flex common-align-center common-justify-between"
            >
              <div class="common-flex common-align-center">
                <div class="order-l-item-label">Gender</div>
              </div>
              <Select class="" v-model="submitOrder.genderId" placeholder="">
                <Option
                  v-for="item in genderList"
                  :value="item.id"
                  :key="item.id"
                >{{ item.name }}
                </Option
                >
              </Select>
            </div>
            <div class="order-l-item common-flex common-align-center">
              <div class="order-l-item-label">Qty</div>
              <Input
                class="order-l-item-ipt"
                type="text"
                v-model="submitOrder.amount"
                placeholder=""
              />
            </div>
            <div class="order-l-item common-flex common-align-center">
              <!-- {{submitOrder.fabric}} -->
              <div class="order-l-item-label">
                Fabric
                <span v-if="submitOrder.inventory"
                >({{ submitOrder.inventory }})</span
                >
              </div>
              <!-- <Select v-model="submitOrder.fabric" @on-change="changeFabri" clearable @on-query-change="queryChangeFabri"
                style="width: 290px" :placeholder="$t('newOrder.placeCommon')" :not-found-text="$t('noDate')" filterable>
                <Option v-for="item in fabricListSearch" :value="item.fabricCode" :key="item.id">{{ item.fabricCode }}</Option>
              </Select> -->
              <!-- <div class="common-flex autoComplete-select"> -->
              <Select
                v-model="submitOrder.fabricType"
                placeholder=" "
                style="width: 70px"
                @on-change="handleSource"
              >
                <Option
                  v-for="item in typeList"
                  :value="item.value"
                  :key="item.value"
                >{{ item.label }}
                </Option
                >
              </Select>
              <Select class="ivu-icon-select" v-if="submitOrder.fabricType == 'sys'" v-model="submitOrder.fabric"
                      @on-change="changeFabri" clearable @on-query-change="queryChangeFabri"
                      @keydown.native="handleKeydown"
                      style="width: 290px" placeholder="Fabric #" :not-found-text="$t('noDate')" filterable>
                <Option v-for="item in fabricListSearch" :value="item.fabricCode" :key="item.id"
                        :label="item.fabricCode">
                  <div class="option-with-image">
                    <Tooltip v-if="item.imgPath" placement="right" max-width="800" transfer>
                      <div class="fabric-item">
                        <span>{{ item.fabricCode }}</span>
                        <Icon type="md-images" style="margin-left: 4px; color: #2d8cf0;"/>
                      </div>
                      <div slot="content" style="background-color: #fff; padding: 10px; border-radius: 4px; box-shadow: 0 3px 10px rgba(0,0,0,0.3);">
                        <img :src="item.imgPath" style="max-width: 550px; max-height: 450px; object-fit: contain; display: block;" />
                      </div>
                    </Tooltip>
                    <template v-else>{{ item.fabricCode }}</template>
                  </div>
                </Option>
              </Select>
              <!-- <AutoComplete
                v-if="submitOrder.fabricType == 'sys'"
                class="autoComplete-select-box"
                clearable
                @on-change="changeFabri"
                v-model="submitOrder.fabric"
                @on-search="queryChangeFabri"
                style="width: 220px"
              >
                <Option
                  v-for="item in fabricListSearch"
                  :value="item.fabricCode"
                  :key="item.id"
                  >{{ item.fabricCode }}
                </Option>
              </AutoComplete> -->
              <Input
                v-if="submitOrder.fabricType == 'cus'"
                class="order-l-item-ipt"
                type="text"
                v-model="submitOrder.fabric"
                placeholder="Fabric #"
              />
              <!-- </div> -->
            </div>

            <div v-for="(item, index) in categroyMsg" :key="index">
              <div
                class="categroy-name"
                v-if="item.accessories && item.accessories.length > 0"
              >
                {{ item.name }}
              </div>
              <div
                class="order-l-item common-flex common-align-center"
                v-for="(aitem, aindex) in item.accessories"
                :key="aindex"
              >
                <div style="width: 50%" class="order-l-item-label">
                  <Tooltip
                    content="Sync this item"
                    placement="right"
                    class="order-l-item-label-icon"
                  >
                    <Icon
                      @click="copyCraft(aitem)"
                      v-if="aitem.chooseType == 'COPY'"
                      type="md-sync"
                    />
                  </Tooltip>
                  {{ aitem.name }}
                </div>
                <div style="width: 50%">
                  <Select
                    style="width: 100%"
                    @on-change="
                      (e) => {
                        changeAccessories(e, aitem);
                      }
                    "
                    v-model="aitem.selectId"
                  >
                    <Option
                      v-for="mitem in aitem.children"
                      :value="mitem.id"
                      :key="mitem.id"
                    >{{ mitem.name }}
                    </Option
                    >
                  </Select>
                  <Input
                    v-if="
                      aitem.selectCraft &&
                      aitem.selectCraft.sourceType == 'TEXT'
                    "
                    class="order-l-item-ipt"
                    type="text"
                    v-model="aitem.selectCraft.value"
                    placeholder="Enter"
                  />
                </div>
              </div>
            </div>

            <!-- <div class="order-l-item common-flex common-align-center">
              <div class="order-l-item-label">Button</div>
              <Input class="order-l-item-ipt" type="text" v-model="qvalue" placeholder="" />
            </div> -->
          </div>
          <!-- 品类详情 或者用户具体信息 -->
          <div class="quick-order-r">
            <div
              class="quick-order-r"
              :style="[
                isFixed
                  ? {
                      position: 'fixed',
                      top: '81px',
                    }
                  : {},
              ]"
            >
              <div class="order-r-optional order-r-box">Optional</div>
              <div class="common-flex order-r-box">
                <div class="order-r-title">Order #</div>
                <Input
                  class="order-r-ipt"
                  v-model="submitOrder.cusOrderCode"
                ></Input>
              </div>
              <div class="common-flex order-r-box">
                <div class="order-r-title">Phone #</div>
                <Input class="order-r-ipt" v-model="submitOrder.phone"></Input>
              </div>
              <div class="common-flex order-r-box">
                <div class="order-r-title">Email</div>
                <Input class="order-r-ipt" v-model="submitOrder.email"></Input>
              </div>
              <div class="common-flex order-r-box">
                <div class="order-r-title">Birthday</div>
                <Input
                  class="order-r-ipt"
                  v-model="submitOrder.birthdate"
                ></Input>
              </div>
              <div class="common-flex order-r-box">
                <div class="order-r-title">Address</div>
                <Input
                  class="order-r-ipt"
                  v-model="submitOrder.address"
                ></Input>
              </div>
              <!--<div class="order-r-box">
                <div
                  class="order-r-title"
                  style="width: 200px; margin-bottom: 15px"
                >
                  Notes
                </div>
                <Input
                  class="order-r-ipt order-r-textarea"
                  style="width: 434px"
                  type="textarea"
                  v-model="submitOrder.memo"
                ></Input>
              </div>-->
            </div>
          </div>

          <!-- <rIntegration style="margin-bottom: 61px;text-align: center;" @chooseCustomer="chooseCustomer"
            :customerId="submitOrder.customerId" :customerName="submitOrder.customerName" :customerList="customerList"
            :customerInfoShow="customerInfoShow">
          </rIntegration> -->
        </div>
        <!-- 内容部分 步骤二 -->
        <div v-if="stepId == 2" class="common-flex quick-order-details">
          <!-- 用户信息或者工艺品类 -->
          <div class="quick-order-l">
            <div
              class="quick-order-l common-rowUnder"
              :style="[
                isFixed
                  ? {
                      position: 'fixed',
                      top: '81px',
                    }
                  : {},
              ]"
              style="overflow-y: auto; overflow-x: hidden"
            >
              <div
                v-for="(craftItem, craftIndex) in categroyMsg"
                :key="craftIndex"
              >
                <!-- {{showCraft.name}}{{showCraft.id}}pp{{ craftItem.id }}/ -->
                <div class="categroy-name">{{ craftItem.name }}</div>
                <div
                  :class="
                    showCraft.id == childItem.id ? 'order-l-item-selects' : ''
                  "
                  @click="chooseCraft(childItem)"
                  v-for="(childItem, childIndex) in craftItem.craft"
                  :key="childIndex"
                  class="order-l-item common-flex common-align-center common-hover"
                >
                  <div class="order-l-item-craft">{{ childItem.name }}</div>
                  <!-- {{ childItem.selectCraft }} -->
                  <!-- <div v-if="childItem.name =='铆钉扣'">
                  {{ childItem.children }}
                </div> -->
                  <!-- <div class="order-l-item-select" v-if="childItem.selectCraft">{{ childItem.selectCraft ?
                  childItem.selectCraft.name : 'Select' }}</div> -->
                  <!-- <div>
                    {{ childItem.selectCraftList }}
                  </div> -->
                  <div
                    class="order-l-item-select"
                    v-if="childItem.selectCraftList"
                  >
                    <span
                      v-for="(sc, sci) in childItem.selectCraftList"
                      :key="sci"
                    >
                      {{ sc.name }} <span v-if="sc.value">-{{ sc.value }}</span>
                      <span v-if="sci != childItem.selectCraftList.length - 1"
                      >/</span
                      >
                    </span>
                  </div>
                </div>
                <!-- 刺绣、 -->
                <div
                  v-if="craftItem.emb && craftItem.emb.length > 0"
                  @click="chooseEmb(craftItem)"
                >
                  <div
                    :class="
                      showEmb.id == craftItem.id ? 'order-l-item-selects' : ''
                    "
                    class="order-l-item common-flex common-align-center common-hover"
                  >
                    <div class="order-l-item-craft">Monogram</div>
                    <div class="order-l-item-select">
                      <!-- {{ craftItem.embList }} -->
                      <span v-for="(sc, sci) in craftItem.embList" :key="sci">
                        {{ sc.siteName }}
                        <span v-if="sci != craftItem.embList.length - 1"
                        >/</span
                        >
                      </span>
                    </div>
                  </div>
                </div>
                <!-- 撞色 -->
                <div
                  v-if="
                    craftItem.colorContrast &&
                    craftItem.colorContrast.length > 0
                  "
                >
                  <!-- :class="showColorContrast.id == craftItem.id ? 'order-l-item-selects' : '' -->
                  <!-- @click="chooseColorContrast(craftItem)" -->
                  <div
                    :class="
                      showColorContrast.id == s.id ? 'order-l-item-selects' : ''
                    "
                    @click="chooseColorContrast(s)"
                    v-for="(s, sindex) in craftItem.colorContrast"
                    :key="sindex"
                    class="order-l-item common-flex common-align-center common-hover"
                  >
                    <div class="order-l-item-craft">{{ s.name }}</div>
                    <div class="order-l-item-select">
                      <span v-for="(kitem, kindex) in s.children" :key="kindex">
                        <!-- {{kitem}}   -->
                        <span
                          v-for="(sc, sci) in kitem.selectContrastList"
                          :key="sci"
                        >
                          {{ sc.name }}
                          <span
                            v-if="sci != kitem.selectContrastList.length - 1"
                          >/</span
                          >
                          <span
                            v-if="
                              kitem.selectContrastListFabric &&
                              sci == kitem.selectContrastList.length - 1
                            "
                          >--({{
                              kitem.selectContrastListFabric.name
                            }}{{
                              kitem.selectContrastListFabric.value
                                ? kitem.selectContrastListFabric.value
                                : ""
                            }})</span
                          >
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 用户信息 -->
            </div>
          </div>

          <!-- 品类详情 或者用户具体信息 -->
          <div class="quick-order-r" v-if="type == 'craft'">
            <!-- 两层二级分类 -->
            <div
              v-if="
                showCraft &&
                showCraft.children &&
                showCraft.children[0].children &&
                showCraft.children[0].children.length > 0
              "
            >
              <!-- <div class="craft-item-box craft-item-box-small" v-for="(item, index) in showCraft.children" :key="index">
                <div class="craft-item">
                  <div class="craft-item-i-box common-hover" :class="(showCraft.selectCraft&&item.id==showCraft.selectCraft.id)?'craft-item-select':''" @click="chooseCraftOne(item)">
                    <img class="craft-item-box-small" :src="item.craftPath" :alt="item.name" srcset="">
                  </div>
                  <div class="craft-item-name">{{ item.name }}</div>
                </div>
              </div> -->
              <div v-for="(yitem, yindex) in showCraft.children" :key="yindex">
                <div class="craft-item-b-title">{{ yitem.name }}</div>
                <!-- 123 -->
                <div class="common-flex common-flex-wrap craft-item-btns">
                  <div
                    class="craft-item-box-small"
                    v-for="(item, index) in yitem.children"
                    :key="index"
                  >
                    <div
                      class="craft-item-small"
                      v-if="yitem.sourceType != 'LABEL'"
                    >
                      <div
                        class="common-hover craft-item-i-box"
                        :class="item.select ? 'craft-item-select' : ''"
                        @click="chooseCraftAny(item, yitem)"
                      >
                        <img
                          style="height: 96px"
                          v-lazy="item.craftPath"
                          :alt="item.name"
                          srcset=""
                        />
                        <div
                          class="craft-item-price"
                          v-if="item.price && item.select"
                        >
                          {{ item.price }}
                        </div>
                      </div>
                      <div
                        class="craft-item-name"
                        :class="item.imgPath ? 'common-hover' : ''"
                        @click="previewImg(item)"
                      >
                        <Icon v-if="item.imgPath" type="md-images"/>
                        {{ item.name }}
                      </div>
                    </div>
                    <div v-else>
                      <div
                        @click="chooseCraftAny(item, yitem)"
                        :class="item.select ? 'contrast-p-name-select' : ''"
                        v-if="item.sourceType == 'TEXT'"
                        class="common-flex common-align-center select-l-text contrast-p-name"
                      >
                        <div
                          class="craft-item-name"
                          :style="[
                            item.select
                              ? { color: '#0a4dcc' }
                              : { color: '#979eaa' },
                          ]"
                          @click="previewImg(item)"
                          :class="item.imgPath ? 'common-hover' : ''"
                          style="
                            margin-top: 0;
                            display: inline-block;
                            width: auto;
                            margin-right: 10px;
                          "
                        >
                          <Icon v-if="item.imgPath" type="md-images"/>
                          {{ item.name }}
                          {{ item.price && item.select ? item.price : "" }}
                        </div>
                        <span @click.stop="">
                          <Input
                            @on-focus="focusCraftAny(item, yitem)"
                            class=""
                            size="small"
                            style="width: 120px"
                            v-model="item.value"
                          />
                        </span>
                      </div>
                      <div
                        v-else
                        @click="chooseCraftAny(item, yitem)"
                        style="margin-right: 0"
                        class="contrast-p-name"
                        :class="item.select ? 'contrast-p-name-select' : ''"
                      >
                        {{ item.name }}
                        {{ item.price && item.select ? item.price : "" }}
                        <!-- {{ item }} -->
                      </div>
                    </div>
                    <!-- <div class="craft-item-small" v-if="yitem.sourceType != 'LABEL'">
                      <div class="common-hover craft-item-i-box"
                        :class="(yitem.selectCraft && item.id == yitem.selectCraft.id) ? 'craft-item-select' : ''"
                        @click="chooseCraftAny(item, yitem)">
                        <img style="height: 96px;" v-lazy="item.craftPath" :alt="item.name" srcset="">
                        <div class="craft-item-price"
                          v-if="item.price && (yitem.selectCraft && item.id == yitem.selectCraft.id)">${{ item.price }}
                        </div>
                      </div>
                      <div class="craft-item-name">{{ item.name }}</div>
                    </div>
                    <div v-else>
                      <div @click="chooseCraftAny(item, yitem)"
                        :class="(yitem.selectCraft && item.id == yitem.selectCraft.id) ? 'contrast-p-name-select' : ''"
                        v-if="item.sourceType == 'TEXT'"
                        class="common-flex common-align-center select-l-text contrast-p-name">
                        <div class="craft-item-name"
                          :style="[(yitem.selectCraft && item.id == yitem.selectCraft.id) ? { color: '#0a4dcc' } : { color: '#979eaa' }]"
                          style="margin-top:0;display:inline-block;width:auto;margin-right: 10px;">{{ item.name }}</div>
                        <span @click.stop="">
                          <Input class="" size="small" style="width:120px" v-model="item.value" />
                        </span>
                      </div>
                      <div v-else @click="chooseCraftAny(item, yitem)" style="margin-right:0" class="contrast-p-name"
                        :class="(yitem.selectCraft && item.id == yitem.selectCraft.id) ? 'contrast-p-name-select' : ''">{{
                          item.name }}</div>
                    </div> -->
                  </div>
                </div>
                <div v-if="(yindex+1)===showCraft.children.length" style="padding-bottom: 100px"></div>
              </div>
            </div>
            <!-- 直接选择二级分类 -->
            <div class="common-flex common-flex-wrap" v-else>
              <!-- <div class="craft-item-box craft-item-box-small" v-for="(item, index) in showCraft.children" :key="index">
                <div class="craft-item">
                  <div class="craft-item-i-box common-hover" :class="(showCraft.selectCraft&&item.id==showCraft.selectCraft.id)?'craft-item-select':''" @click="chooseCraftOne(item)">
                    <img class="craft-item-box-small" :src="item.craftPath" :alt="item.name" srcset="">
                  </div>
                  <div class="craft-item-name">{{ item.name }}</div>
                </div>
              </div> -->
              <div class="common-flex common-flex-wrap craft-item-btns">
                <div
                  class="craft-item-box-small"
                  v-for="(item, index) in showCraft.children"
                  :key="index"
                >
                  <div class="craft-item-small">
                    <div
                      class="common-hover craft-item-i-box"
                      :class="item.select ? 'craft-item-select' : ''"
                      @click="chooseCraftOne(item)"
                    >
                      <img
                        style="height: 96px"
                        v-lazy="item.craftPath"
                        :alt="item.name"
                        srcset=""
                      />
                      <div
                        class="craft-item-price"
                        v-if="item.price && item.select"
                      >
                        {{ item.price }}
                      </div>
                    </div>
                    <!-- <div class="common-hover craft-item-i-box"
                      :class="(showCraft.selectCraft && item.id == showCraft.selectCraft.id) ? 'craft-item-select' : ''"
                      @click="chooseCraftOne(item)">
                      <img style="height: 96px;" v-lazy="item.craftPath" :alt="item.name" srcset="">
                      <div class="craft-item-price"
                        v-if="item.price && (showCraft.selectCraft && item.id == showCraft.selectCraft.id)">${{ item.price
                        }}
                      </div>
                    </div> -->
                    <div
                      class="craft-item-name"
                      @click="previewImg(item)"
                      :class="item.imgPath ? 'common-hover' : ''"
                    >
                      <Icon v-if="item.imgPath" type="md-images"/>
                      {{ item.name }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 二级分类 输入价格 -->
            <div v-if="false">
              <div class="common-flex common-flex-wrap craft-item-btns">
                <div
                  class="craft-item-box-small"
                  v-for="(item, index) in 10"
                  :key="index"
                >
                  <div class="craft-item-small">
                    <div class="craft-item-i-box craft-item-select">
                      <div class="craft-item-price">$20.00</div>
                    </div>
                    <div class="craft-item-name">Normal</div>
                  </div>
                </div>
              </div>
              <div>
                <div class="craft-optional">
                  Laser On Waistband Button (Optional)
                </div>
                <!-- 输入价格类型 -->
                <div
                  class="craft-set-price common-flex common-align-center common-justify-between"
                >
                  <Input
                    style="width: 200px"
                    placeholder="Max 6 characters"
                  ></Input>
                  <div class="craft-price">+$20.00</div>
                </div>
                <!-- 选择选择图片类型 -->
                <div class="common-flex common-flex-wrap craft-item-btns">
                  <div
                    class="craft-item-box-small"
                    v-for="(item, index) in 10"
                    :key="index"
                  >
                    <div class="craft-item-small">
                      <div class="craft-item-i-box craft-item-select">
                        <div class="craft-item-price">$20.00</div>
                      </div>
                      <div class="craft-item-name">Normal</div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Leather Patch Laser -->
              <div>
                <div class="craft-optional">Leather Patch Laser</div>
                <div class="common-flex common-align-center craft-from-box">
                  <div class="craft-from">From</div>
                  <Select v-model="model" style="width: 200px">
                    <Option
                      v-for="item in cityList"
                      :value="item.value"
                      :key="item.value"
                    >{{ item.label }}
                    </Option
                    >
                  </Select>
                </div>
                <div class="common-flex common-align-center craft-from-box">
                  <div class="craft-from">Content</div>
                  <Input
                    v-model="qvalue"
                    style="width: 200px"
                    placeholder="Max 15 characters"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="quick-order-r" v-if="type == 'emb'">
            <!-- emb -->
            <!-- 刺绣组 -->
            <!-- <div class="emb-title">Jacket</div> -->
            <div class="common-flex common-flex-wrap">
              <div
                class="emb-item"
                :style="[(embIndex + 1) % 3 == 0 ? { marginRight: 0 } : {}]"
                v-for="(embItem, embIndex) in showEmb.embList"
                :key="embIndex"
              >
                <div
                  class="common-flex common-align-center craft-from-box craft-from-box-bottom"
                >
                  <div class="craft-from">Position</div>
                  <Select
                    v-model="embItem.site"
                    style="width: 200px"
                    :label-in-value="false"
                    @on-change="
                      (e) => {
                        changeEmb(e, embItem, showEmb);
                      }
                    "
                  >
                    <Option
                      v-for="item in showEmb.emb"
                      :value="item.id"
                      :key="item.id"
                    >
                      {{ item.name }}
                      <Tooltip v-if="item.imgPath" placement="right" max-width="800" transfer>
                        <Icon type="md-images" style="margin-left: 4px; color: #2d8cf0;"/>
                        <div slot="content" style="background-color: #fff; padding: 10px; border-radius: 4px; box-shadow: 0 3px 10px rgba(0,0,0,0.3);">
                          <img :src="item.imgPath" style="max-width: 550px; max-height: 450px; object-fit: contain; display: block;" />
                        </div>
                      </Tooltip>
                    </Option>
                  </Select>
                </div>
                <div
                  class="common-flex common-align-center craft-from-box craft-from-box-bottom"
                >
                  <div class="craft-from">Color</div>
                  <Select
                    @on-open-change="
                      (e) => {
                        queryChangeColor('', showEmb, embItem);
                      }
                    "
                    clearable
                    v-model="embItem.color"
                    @on-clear="clearColor('', showEmb, embItem)"
                    style="width: 200px"
                    :placeholder="$t('newOrder.placeCommon')"
                    :not-found-text="$t('noDate')"
                    :remote-method="
                      (e) => {
                        queryChangeColor(e, showEmb, embItem);
                      }
                    "
                    filterable
                  >
                    <Option
                      v-for="item in embItem.searchColor"
                      :value="item.id"
                      :key="item.id"
                    >{{ item.name }}
                    </Option
                    >
                  </Select>
                  <!-- <rSearchEmb @queryChange="queryChangeColor" @change="changeColor" :config="showEmb" :list="searchColor">
                  </rSearchEmb> -->
                  <!-- <Select v-model="model" style="width: 200px">
                    <Option v-for="item in cityList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                  </Select> -->
                </div>
                <div
                  class="common-flex common-align-center craft-from-box craft-from-box-bottom"
                >
                  <div class="craft-from">Font</div>
                  <Select
                    @on-open-change="
                      (e) => {
                        queryChangeFont('', showEmb, embItem);
                      }
                    "
                    v-model="embItem.font"
                    @on-clear="clearFont('', showEmb, embItem)"
                    style="width: 200px"
                    :placeholder="$t('newOrder.placeCommon')"
                    :not-found-text="$t('noDate')"
                  >
                    <Option
                      v-for="item in embItem.searchFont"
                      :value="item.id"
                      :key="item.id"
                      :label="item.name"
                    >
                      <div
                        class="flex"
                        style="
                          align-items: center;
                          display: flex;
                          justify-content: space-between;
                        "
                      >
                        <img
                          :src="item.craftPath"
                          alt=""
                          style="width: 40px; height: 40px"
                        />
                        <span
                          style="float: right; color: #ccc; margin-left: 4px"
                        >{{ item.name }}</span
                        >
                      </div>
                    </Option>
                  </Select>
                  <!-- <Select v-model="model" style="width: 200px">
                    <Option v-for="item in cityList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                  </Select> -->
                </div>
                <div
                  v-if="showEmbSize"
                  class="common-flex common-align-center craft-from-box craft-from-box-bottom"
                >
                  <div class="craft-from">Size</div>
                  <!-- <div>{{ embItem.searchSize }}</div> -->
                  <Select
                    @on-open-change="
                      (e) => {
                        queryChangeSize('', showEmb, embItem);
                      }
                    "
                    v-model="embItem.embSize"
                    style="width: 200px"
                    :placeholder="$t('newOrder.placeCommon')"
                    :not-found-text="$t('noDate')"
                  >
                    <Option
                      v-for="item in embItem.searchSize"
                      :value="item.id"
                      :key="item.id"
                      :label="item.name"
                    >{{ item.name }}
                    </Option
                    >
                  </Select>
                  <!-- <Select v-model="model" style="width: 200px">
                    <Option v-for="item in cityList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                  </Select> -->
                </div>
                <div
                  class="common-flex common-align-center craft-from-box craft-from-box-bottom"
                >
                  <div class="craft-from">Content</div>
                  <Input v-model="embItem.embContent" style="width: 200px">
                    <template #append>
                      <Icon
                        class="common-hover"
                        type="ios-trash"
                        @click="delEmb(embIndex)"
                      />
                    </template>
                  </Input>
                </div>
              </div>

              <div class="md-add common-hover" @click="addEmb">
                <Icon type="md-add"/>
              </div>
            </div>
          </div>
          <div class="quick-order-r" v-if="type == 'colorContrast'">
            <!-- {{ showColorContrast }}111 -->
            <div
              v-for="(contrast, contrastIndex) in showColorContrast.children"
              :key="contrastIndex"
            >
              <div class="craft-item-b-title">{{ contrast.name }}</div>
              <div class="common-flex common-flex-wrap">
                <!-- <div class="contrast-p-name common-hover" :class="pitem.select ? 'contrast-p-name-select' : ''"
                  @click="chooseContrast(pitem, contrast)" v-for="(pitem, pindex) in contrast.children" :key="pindex">
                  {{ pitem.name }}
                  pitem.craftPath

                </div> -->
                <div
                  class="craft-item-box-small"
                  v-for="(pitem, pindex) in contrast.children"
                  :key="pindex"
                >
                  <div class="craft-item-small">
                    <div
                      class="common-hover craft-item-i-box"
                      :class="pitem.select ? 'craft-item-select' : ''"
                      @click="chooseContrast(pitem, contrast)"
                    >
                      <img
                        style="height: 96px"
                        v-lazy="pitem.craftPath"
                        :alt="pitem.name"
                        srcset=""
                      />
                    </div>
                    <div
                      class="craft-item-name"
                      @click="previewImg(pitem)"
                      :class="pitem.imgPath ? 'common-hover' : ''"
                    >
                      <Icon v-if="pitem.imgPath" type="md-images"/>
                      {{ pitem.name }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="quick-line"></div>
              <div class="craft-item-b-title">
                {{ $t("quickorder.contrastFabric") }}
              </div>
              <div class="common-flex common-flex-wrap">
                <div
                  class="common-hover"
                  @click="chooseContrastFabric(fitem, contrast)"
                  v-for="(
                    fitem, findex
                  ) in showColorContrast.colorContrastFabric"
                  :key="findex"
                >
                  <div
                    class="contrast-p-name"
                    :class="fitem.select ? 'contrast-p-name-select' : ''"
                    v-if="fitem.sourceType == 'IMAGE'"
                  >
                    {{ fitem.name }}
                  </div>
                  <div v-if="fitem.sourceType == 'TEXT'">
                    <Poptip
                      trigger="hover"
                      :content="fitem.price"
                      :disabled="fitem.price ? false : true"
                    >
                      <div
                        class="contrast-p-name common-flex common-align-center"
                        :class="fitem.select ? 'contrast-p-name-select' : ''"
                      >
                        <div>{{ fitem.name }}</div>
                        <span @click.stop="">
                          <Input
                            @on-focus="focusFabric(fitem, contrast)"
                            class=""
                            size="small"
                            style="width: 120px"
                            v-model="fitem.value"
                          />
                        </span>
                      </div>
                    </Poptip>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 内容部分 步骤三 -->
        <div v-if="stepId == 3" class="common-flex quick-order-details">
          <div class="quick-order-l-box">
            <div
              class="quick-order-l"
              style="overflow-y: auto; overflow-x: hidden"
              :class="
                specBodyParams.sizeType != 10054
                  ? 'common-rowUnder'
                  : 'common-rowUnder-hide'
              "
              :style="[
                specBodyParams.sizeType != 10054
                  ? { width: '450px' }
                  : { width: '1433px' },
                isFixed
                  ? {
                      position: 'fixed',
                      top: '81px',
                    }
                  : {},
              ]"
            >
              <!-- {{ specBodyParams.sizeType }} -->
              <!-- 顶部信息 -->
              <div class="customer-info">
                <div class="common-flex">
                  <div style="text-align: left">
                    <!-- <div class="title">{{ $t("newOrder.tailored") }}</div> -->
                    <Select
                      v-model="specBodyParams.sizeType"
                      @on-change="changeTailored"
                      :placeholder="$t('newOrder.placeholder')"
                      style="width: 330px; margin: 10px 0"
                    >
                      <Option
                        v-for="item in tailoredList"
                        :value="item.id"
                        :key="item.id"
                      >{{ item.name }}
                      </Option
                      >
                    </Select>
                  </div>
                  <div
                    v-if="isAddShow"
                    style="text-align: left; margin-left: 40px"
                  >
                    <div class="title">{{ $t("newOrder.suit") }}</div>
                    <Select
                      v-model="submitOrder.addProduct"
                      :placeholder="$t('newOrder.placeholder')"
                      style="width: 400px; margin: 10px 0"
                    >
                      <Option
                        v-for="item in isAddList"
                        :value="item.id"
                        :key="item.id"
                      >{{ item.name }}
                      </Option
                      >
                    </Select>
                  </div>
                </div>
              </div>
              <!-- ;量体信息 -->
              <div class="measurements">
                <rMeasurements
                  :preSubmitShow="true"
                  :right="60"
                  @preSubmit="preSubmit"
                  :standardChooseParent="standardChoose"
                  @measureInfo="measureInfo"
                  @changeSizeId="changeSizeId"
                  @changeStandard="changeStandard"
                  @changeEditOnce="changeEditOnce"
                  :garmentSize="garmentSize"
                  :unit="customerDetails"
                  :standardList="standardList"
                  :sizeTypeId="specBodyParams.sizeType"
                  :clothing="clothing"
                  :editOnce="editOnce"
                  :categoryMessage="categoryMessage"
                ></rMeasurements>
              </div>
            </div>
          </div>
          <div
            class="quick-order-r common-rowUnder"
            v-if="styleList.length > 0"
          >
            <!-- 特体信息 -->
            <!-- <div class="dress-style" v-if="styleList.length > 0"> -->
            <div class="dress-style-title">
              {{ $t("newOrder.bodyPosture") }}
            </div>
            <div class="common-flex" style="padding-bottom: 50px">
              <rDressStyle
                :listWidth="760"
                :styleList="styleList"
                @changeStyle="changeStyle"
              ></rDressStyle>
              <!-- <div class="dress-img" v-if="chooseStyleMsg.chooseStyleImg">
                <img :src="chooseStyleMsg.chooseStyleImg" alt="" />
                <div>{{ chooseStyleMsg.chooseStyleContent }}</div>
              </div> -->
            </div>
          </div>
          <!-- 着装风格 -->
          <div class="clothing" v-if="clothing.length > 0"></div>
        </div>
        <!-- </div> -->
      </div>
    </form>
    <div class="quick-btns common-flex common-flex-end" @click.prevent="">
      <div>
        <Button @click="previous" v-if="stepId > 1">
          &lt; {{ $t("newOrder.previous") }}
        </Button
        >
        <Button @click="next" v-if="stepId < 3"
        >{{ $t("newOrder.next") }} &gt;
        </Button
        >
        <Button
          @click="submit"
          v-if="stepId == 3"
          style="background: #da8100; color: #fff"
        >
          {{ $t("newOrder.saveCart") }}
        </Button
        >
        <Button
          type="primary"
          style="background: #2d8cf0"
          v-if="stepId == 3"
          @click="submit('order')"
        >{{ $t("newOrder.submit") }}
        </Button>
      </div>
    </div>
  </div>
</template>
<script>
import rSearchEmb from "../../components/r-search-emb";
import rIntegration from "../../components/r-integration";
import rMeasurements from "../../components/r-measurements-quick";
import rDressStyle from "../../components/r-dress-style-quick";
import {cmToInch, inchToCom, getBrowserLang, getToken} from "../../libs/util";
import {api as viewerApi} from "v-viewer";
import {mapActions} from "vuex";
import _ from "lodash";

export default {
  data() {
    return {
      needGetStyleInfo: true,
      orderCode: "",
      // 产品列表
      typeList: [
        {
          value: "sys",
          label: "MTM",
        },
        {
          value: "cus",
          label: "CMT",
        },
      ],
      typeCode: "",
      shapeCategory: "",
      // 是否成功请求预提交接口
      isPreSubmit: false,
      isFixed: false,
      showEmbSize: false, //是否显示刺绣Size
      spinShow: false,
      searchColor: [],
      model: "cm",
      type: "craft",
      customerList: [],
      customerInfoShow: true,
      nochangeBzh: false,
      cityList: [
        {
          value: "cm",
          label: "CM",
        },
      ],
      embMsg: {
        color: "", //颜色
        embContent: "", //内容
        embSize: "", //绣字大小id
        font: "", //字体id
        site: "", //位置id
        file: "",
        siteName: "", //位置名称
        searchColor: [],
        searchFont: [],
        searchSize: [],
        _initialized: false, // 标记是否已初始化
      },
      detailList: {
        clothCategory: 0, //服装分类id
        // craftMap: {
        //工艺信息
        // description: "",
        // },
        craftList: [],
        contrastSaveList: [
          // {
          //   color:'',//颜色id 位置id
          //   site:''
          // }
        ], //撞色信息
        embList: [
          //刺绣信息
          // {
          //   color: "", //颜色
          //   embContent: "", //内容
          //   embSize: "", //绣字大小id
          //   font: "", //字体id
          //   site: "", //位置id
          // },
        ],
        shape: "", //号型
        sizeList: [
          //尺寸信息
          {
            // modifyValue: 0, //调整值id
            // partId: 0, //尺寸部位id
            // partValue: 0, //尺寸值id
          },
        ],
        styleId: "", //着装风格id
      },
      submitOrder: {
        fabricType: "sys", //面料类型
        onlySize: 1,
        inventory: "",
        custInfo: "",
        fabric: "", //面料编码
        detailList: [
          //订单明细
          // {
          //   clothCategory: 0, //服装分类id
          //   // craftMap: {
          //   //工艺信息
          //   // description: "",
          //   // },
          //   craftList: [],
          //   embList: [
          //     //刺绣信息
          //     // {
          //     //   color: "", //颜色
          //     //   embContent: "", //内容
          //     //   embSize: "", //绣字大小id
          //     //   font: "", //字体id
          //     //   site: "", //位置id
          //     //   file: "",
          //     // },
          //   ],
          //   sizeList: [
          //     //尺寸信息
          //     {
          //       modifyValue: 0, //调整值id
          //       partId: 0, //尺寸部位id
          //       partValue: 0, //尺寸值id
          //     },
          //   ],
          //   styleId: 0, //着装风格id
          // },
        ],
        bodyTypeList: [], //特体
        addProduct: 0, //追加产品 1是 0否
        amount: 1, //数量
        clothCategory: 0, //服装分类id
        //** 地址信息----------*/
        customerName: "", //客户名称
        shortName: "", //昵称
        genderId: "", //性别
        height: "", //身高
        heightUnit: "", //身高单位
        weight: "", //体重
        weightUnit: "", //体重单位
        phone: "", //手机号
        email: "", //邮箱
        address: "", //地址
        birthdate: "", //birthdate
        customerId: "", //客户id //选择客户时已赋值
        //** 地址信息---------*/
        cusOrderCode: "", //客户单号
        orderId: "", //订单号ID （编辑使用）
        sizeAreaId: "", //号型大类id （亚码 欧码）
        sizeCategoryId: "", //尺寸分类id（净体成衣标准号）
        type: "7", //下单类型 (简单下单，代码下单)
        style: "", //长短款
        memo: "", //订单备注
        remark: "", //备注
        orderInfo: "",
      },
      embContent: {
        color: "", //颜色
        colorName: "", //颜色名字
        embContent: "", //内容
        embSize: "", //绣字大小id
        embSizeName: "", //绣字大小名字
        font: "", //字体id
        fontName: "", //字体名字
        site: "", //位置id
      },
      genderList: [],
      weightList: [],
      heightList: [],
      qvalue: "",
      productId: "",
      stepId: 1,
      // getCategoryList: [
      //   {
      //     id: 1,
      //     name: "？？",
      //   },
      // ],
      fabricListSearch: [],
      product: [],
      categroyMsg: "", //工艺信息
      stepList: [
        {
          name: this.$t("quickorder.stepName.one"),
          step: 1,
        },
        {
          name: this.$t("quickorder.stepName.two"),
          step: 2,
        },
        {
          name: this.$t("quickorder.stepName.three"),
          step: 3,
        },
      ],
      showCraft: "", //点击后显示的工艺
      showEmb: "", //点击后显示的刺绣
      showColorContrast: "", //点击后显示的撞色
      tailoredList: [], //量体方式
      // 特体参数
      specBodyParams: {
        sizeType: "",
        category: "",
        customerId: "",
      },
      isAddShow: false,
      // 选择标准号的参数（需加入json中编辑使用）
      standardChoose: {
        property: "", //finished||size  size需要传当前加减值
        id: "", //选择的尺码类型  欧码 亚码
        sizeId: "",
      },
      garmentSize: [], //成衣尺寸
      customerDetails: "", //客户详情
      // 尺码类型
      standardList: [],
      // 特体信息（需加入json中编辑使用）
      styleList: [],
      //着装风格 （需加入json中编辑使用）
      clothing: [],
      // 是否是编辑初次进入
      editOnce: false,
      // 选择的特体图片
      chooseStyleMsg: {
        chooseStyleImg: "",
        chooseStyleContent: "",
      },
      categoryMessage: "",
      changeCusNum: 0,
      noChangeEdit: false,
      noChange: false,
      queryOrderId: "",
      customer: [],
    };
  },
  components: {
    rIntegration,
    rSearchEmb,
    rMeasurements,
    rDressStyle,
  },
  watch: {
    // 监听单位
    "customerDetails.heightUnit": {
      handler(newval, oldval) {
        if (oldval && newval != oldval) {
          // console.log("转", newval, oldval);
          if (newval == 10266) {
            //英寸转厘米
            if (this.specBodyParams.sizeType == 10054) {
              this.cmsAll();
            } else {
              this.cms();
            }
          } else if (newval == 10265) {
            //厘米转英寸
            if (this.specBodyParams.sizeType == 10054) {
              this.inchsAll();
            } else {
              this.inchs();
            }
          }
        }
      },
      immediate: true,
      deep: true,
    },
    categroyMsg: {
      handler(newval, oldval) {
        if (newval.length > 0) {
          let craftPriceData = [];
          newval.map((item, index) => {
            // 对工艺及辅料进行 显示处理
            // this.chooseIds = "";
            craftPriceData.push({
              category: item.id,
              chooseIds: "",
            });
            if (item.craftList.length > 0) {
              item.craftList.map((allItem) => {
                if (allItem.category == 1 || allItem.category == 3) {
                  if (allItem.children && allItem.children.length > 0) {
                    this.handlecraftId(
                      allItem.children,
                      craftPriceData[craftPriceData.length - 1],
                      allItem
                    );
                  }
                }
              });
            }
          });

          this.getCraftPrice(craftPriceData);
        }
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
    $route: {
      handler() {
        // 如果是编辑
        // this.listDictSystem(); //量体方式
        // this.zzCraft(this.$route.query.id); //工艺信息
        // if (!this.$route.query.orderId) {
        //   this.zzFabric(this.$route.query.id); //面料信息
        // }
        // this.specBodyParams.category = this.$route.query.id;
        // this.getGenderDictSystem(); //性别
        // this.getHeightDictSystem(); //身高单位
        // this.getWeightDictSystem(); //体重单位
        // this.isAdd(); //是否追加西裤
        // this.stepId = 1;
        this.productId = Number(this.$route.query.id);
        this.getCategory();
      },
      deep: true,
      immediate: true,
    },
  },
  // <Icon type="md-sync" />
  mounted() {
    // this.productId = this.$route.query.id

    this.getCategory();

    this.getUnit();
    if (this.$route.query.orderId) {
      this.queryOrderId = this.$route.query.orderId;
    }
  },
  updated() {
    // 确保所有刺绣项都有正确的显示值
    if (this.showEmb && this.showEmb.embList && this.showEmb.embList.length > 0) {
      this.showEmb.embList.forEach(item => {
        if (item.site && !item._initialized) {
          this.initEmbItem(item);
        }
      });
    }
  },
  methods: {
    ...mapActions([
      // "zzSpecBodyAction",
      "getDictSystemAction", //字典
      "zzFabricAction", //查询面料
      "getCategoryAction", //查询品类
      "simpleGetFabricStockAction", //查询库存
      "getCustAction", //查询客户
      "zzCraftAction", //查询工艺
      "zzEmbAction", //刺绣信息
      "zzContrastAction", //撞色信息
      "listDictSystemAction", //量体方式
      "measureInfoAction", //量体方式
      "zzSpecBodyAction", //特体信息
      "standardAction", //尺码类型
      "searchCraftAction", //搜索替换工艺
      "styleInfoAction", //着装风格
      "saveOrderAction", //保存订单
      "submitOrderAction", //提交订单
      "editOrderAction", //编辑的数据
      "getCraftPriceAction", //获取价格
      "getFinishedSizeAction", //获取尺码
    ]),
    previewImg(e) {
      if (e.imgPath) {
        const $viewer = viewerApi({
          options: {
            toolbar: false,
            navbar: false,
          },
          images: [e.imgPath],
        });
      }
    },
    changeEmb(a, b, c) {
      // 根据选择的ID更新名称和site属性
      c.emb.forEach((s) => {
        if (s.id == a) {
          b.siteName = s.name;
          
          // 确保site值是正确的ID
          this.$nextTick(() => {
            b.site = a;
          });
        }
      });
      
      // 强制刷新视图
      this.$forceUpdate();
    },
    handleSource() {
      this.submitOrder.fabric = ''
      this.submitOrder.inventory = ''
    },
    handleScroll(event) {
      if (event.target.scrollTop > 25) {
        this.isFixed = true;
      } else {
        this.isFixed = false;
      }
    },
    copyCraft(item) {
      // item  value

      let cname = "";
      item.children.map((c) => {
        if (item.selectId == c.id) {
          cname = c.name;
        }
      });
      // console.log(item);
      this.categroyMsg.map((s) => {
        s.accessories.map((p) => {
          if (p.name == item.name) {
            p.children.map((y) => {
              if (y.name == cname) {
                p.selectId = y.id;
                if (item.selectCraft.value) {
                  y.value = item.selectCraft.value;
                }
                p.selectCraft = JSON.parse(JSON.stringify(y));
              }
            });
            this.$forceUpdate();
            // console.log(p)
          }
        });
      });
    },
    handleSearch(e) {
      this.getCustAction({keywords: e}).then((res) => {
        // console.log("res", res);
        this.customer = res.data;
      });
    },
    changeCus(e) {
      this.customer.map((item) => {
        // console.log(1213, e);
        if (e == item.custName) {
          this.chooseCustomer(item);
          // this.$emit("chooseCustomer", item);
        }
      });
      // console.log(123, e);
    },
    // 递归获取工艺
    handlecraftId(children, craftItem, s) {
      children.map((item) => {
        if (item.children && item.children.length > 0) {
          if (
            s.selectCraft &&
            craftItem.chooseIds.split(",").indexOf(String(s.selectCraft.id)) ==
            -1
          ) {
            craftItem.chooseIds += s.selectCraft.id + ",";
          }
          if (s.selectCraftList) {
            s.selectCraftList.map((o) => {
              if (craftItem.chooseIds.split(",").indexOf(String(o.id)) == -1) {
                craftItem.chooseIds += o.id + ",";
              }
            });
          }
          this.handlecraftId(item.children, craftItem, item);
        } else {
          if (
            s.selectCraft &&
            craftItem.chooseIds.split(",").indexOf(String(s.selectCraft.id)) ==
            -1
          ) {
            craftItem.chooseIds += s.selectCraft.id + ",";
          }
          if (s.selectCraftList) {
            s.selectCraftList.map((o) => {
              if (craftItem.chooseIds.split(",").indexOf(String(o.id)) == -1) {
                craftItem.chooseIds += o.id + ",";
              }
            });
          }
          // if (item.isDefault === 1) {
          //   craftItem.chooseIds += item.id + ",";
          //   return false;
          // }
        }
      });
    },
    // 递归更新价格
    updatePrice(e, pitem) {
      e.children.map((citem) => {
        if (citem.id == pitem.id) {
          if (citem.price != pitem.price) {
            // citem.price = pitem.price||0
            this.$set(citem, "price", pitem.price);
          }
        }
        if (citem.children) {
          this.updatePrice(citem, pitem);
        }
      });
    },

    // 更新价格
    getCraftPrice(data) {
      this.getCraftPriceAction(data).then((res) => {
        // res.data[0].price = '￥900'
        res.data.map((pitem) => {
          this.categroyMsg.map((item) => {
            item.craftList.map((citem) => {
              if (citem.id == pitem.id) {
                if (citem.price != pitem.price) {
                  // citem.price = pitem.price||0
                  this.$set(citem, "price", pitem.price);
                }
              }
              if (citem.children) {
                this.updatePrice(citem, pitem);
              }
            });
          });
        });
      });
    },
    // 获得编辑数据
    editOrder() {
      this.editOrderAction({
        orderId: this.$route.query.orderId,
        type:
          this.$route.query.orderType &&
          this.$route.query.orderType === "buyagain"
            ? "buy"
            : "edit",
      }).then((res) => {
        this.isPreSubmit = true;
        this.orderCode =
          this.$route.query.orderType === "buyagain" ? "" : res.data.orderCode;

        // 检查是否存在可编辑的品类
        let pass = false;
        res.data.detailList.map((s) => {
          this.categroyMsg.map((p) => {
            if (s.clothCategory == p.id) {
              pass = true;
            }
          });
        });
        
        if (pass) {
          // 设置客户详情信息
          this.customerDetails = {
            heightUnitName: res.data.heightUnitName,
            heightUnit: res.data.heightUnit,
          };
          
          // 保存订单数据
          this.submitOrder = res.data;
          this.submitOrder.onlySize = 1;
          
          // 查询面料库存
          if (this.submitOrder.fabric) {
            this.simpleGetFabricStockAction({
              fabricCode: this.submitOrder.fabric,
            }).then((res) => {
              this.submitOrder.inventory = res.data;
              this.$forceUpdate();
            });
            
            // 查询面料信息
            this.zzFabricAction({
              clothCategory: this.productId,
              keywords: this.submitOrder.fabric,
            }).then((res) => {
              this.fabricListSearch = res.data;
            });
          }
          
          // 处理其他订单信息
          if (res.data.orderInfo) {
            this.processOrderInfoJson(res.data.orderInfo);
          }
          
          // 先清空选择状态，避免冲突
          this.resetAllCraftSelections();
          
          // 应用订单中的工艺选择
          this.applyOrderCraftSelections(res.data.detailList);
          
          // 更新所有工艺预览
          this.$nextTick(() => {
            this.updateAllPreviews();
            
            // 激活第一个品类
            if (this.categroyMsg.length > 0) {
              this.chooseCraft(this.categroyMsg[0]);
            }
            
            // 处理尺寸数据
            if (this.noChange || this.noChangeEdit) {
              this.cms();
              this.cmsAll();
            }
          });
        } else {
          this.needGetStyleInfo = true;
        }
      });
    },

    // 重置所有工艺选择状态
    resetAllCraftSelections() {
      if (!this.categroyMsg) return;
      
      this.categroyMsg.forEach(category => {
        // 重置工艺选择
        if (category.craft) {
          category.craft.forEach(craft => {
            this.resetCraftSelection(craft);
          });
        }
        
        // 重置辅料选择
        if (category.accessories) {
          category.accessories.forEach(acc => {
            this.$set(acc, "selectCraft", null);
            this.$set(acc, "selectId", null);
            
            // 递归重置子项
            if (acc.children) {
              acc.children.forEach(child => {
                this.$set(child, "select", false);
                this.$set(child, "isDefault", 0);
                this.$set(child, "value", ""); // 清空文本内容
                
                if (child.children) {
                  this.resetChildrenSelection(child.children);
                }
              });
            }
          });
        }
        
        // 重置撞色选择
        if (category.colorContrast) {
          category.colorContrast.forEach(contrast => {
            if (contrast.children) {
              contrast.children.forEach(child => {
                this.$set(child, "selectContrastList", []);
                this.$set(child, "selectContrastListFabric", null);
                
                if (child.children) {
                  child.children.forEach(item => {
                    this.$set(item, "select", false);
                    this.$set(item, "isDefault", 0);
                    
                    if (item.children) {
                      this.resetChildrenSelection(item.children);
                    }
                  });
                }
              });
            }
            
            // 重置撞色面料选择
            if (contrast.colorContrastFabric) {
              contrast.colorContrastFabric.forEach(fabric => {
                this.$set(fabric, "select", false);
                this.$set(fabric, "value", ""); // 清空文本内容
              });
            }
          });
        }
      });
      
      // 强制视图更新
      this.$forceUpdate();
    },
    
    // 递归重置子项选择状态
    resetChildrenSelection(children) {
      if (!children) return;
      
      children.forEach(item => {
        this.$set(item, "select", false);
        this.$set(item, "isDefault", 0);
        this.$set(item, "value", ""); // 清空文本内容
        
        if (item.children) {
          this.resetChildrenSelection(item.children);
        }
      });
    },

    // 递归重置工艺选择
    resetCraftSelection(craft) {
      if (!craft) return;
      
      // 重置选择列表
      this.$set(craft, "selectCraftList", []);
      this.$set(craft, "selectCraft", null);
      
      // 递归处理子项
      if (craft.children) {
        craft.children.forEach(child => {
          // 重置单个项的选择状态
          this.$set(child, "select", false);
          this.$set(child, "isDefault", 0);
          
          // 递归处理更深层级
          if (child.children) {
            this.resetCraftSelection(child);
          }
        });
      }
    },

    // 应用订单工艺选择
    applyOrderCraftSelections(detailList) {
      if (!detailList || !this.categroyMsg) return;
      
      // 应用订单中的工艺选择
      detailList.forEach(detail => {
        const category = this.categroyMsg.find(c => c.id === detail.clothCategory);
        if (!category) return;
        
        // 应用辅料选择
        if (category.accessories) {
          category.accessories.forEach(acc => {
            if (acc.children) {
              this.applyAccessoriesSelection(acc, detail);
            }
          });
        }
        
        // 应用工艺选择
        if (category.craft) {
          category.craft.forEach(craft => {
            if (craft.children) {
              this.applyCraftSelection(craft, detail);
            }
          });
        }
        
        // 应用刺绣选择
        if (detail.embList && detail.embList.length > 0) {
          category.embList = detail.embList.map(em => {
            // 创建新对象以避免引用问题
            const embItem = {...em};
            
            // 初始化搜索字段
            embItem.searchFont = [{id: em.font, name: em.fontName}];
            embItem.searchSize = [{id: em.embSize, name: em.embSizeName}];
            embItem.searchColor = [{id: em.color, name: em.colorName}];
            
            // 设置位置名称
            if (category.emb) {
              const position = category.emb.find(e => e.id === em.site);
              if (position) {
                embItem.siteName = position.name;
              }
            }
            
            return embItem;
          });
        }
        
        // 应用撞色选择
        if (category.colorContrast) {
          category.colorContrast.forEach(contrast => {
            if (contrast.children) {
              this.applyContrastSelection(contrast, detail, category);
            }
          });
        }
      });
    },
    
    // 清除对象中的选择状态
    clearSelectionStates(obj) {
      if (!obj || typeof obj !== 'object') return;
      
      if (Array.isArray(obj)) {
        obj.forEach(item => this.clearSelectionStates(item));
        return;
      }
      
      // 清除选择状态属性
      if ('select' in obj) obj.select = false;
      if ('isDefault' in obj) obj.isDefault = 0;
      if ('value' in obj) obj.value = '';
      
      // 递归处理子对象
      if (obj.children) {
        this.clearSelectionStates(obj.children);
      }
    },

    // 应用辅料选择
    applyAccessoriesSelection(accessories, detail) {
      if (!detail.craftList || !accessories.children) return;
      
      accessories.children.forEach(child => {
        const craftItem = detail.craftList.find(craft => craft.id === child.id);
        if (craftItem) {
          accessories.selectCraft = child;
          accessories.selectId = child.id;
          
          // 设置文本内容
          if (craftItem.content) {
            this.$set(accessories.selectCraft, "value", craftItem.content);
          }
        }
        
        // 递归处理子项
        if (child.children) {
          this.applyAccessoriesSelection(child, detail);
        }
      });
    },

    // 应用工艺选择
    applyCraftSelection(craft, detail) {
      if (!detail.craftList || !craft.children) return;
      
      // 找出当前工艺下被选中的项
      const selectedItems = [];
      
      // 递归处理工艺子项
      const processCraftItem = (item) => {
        if (!item.children) {
          // 叶子节点，检查是否在订单工艺列表中
          const matchedCraft = detail.craftList.find(c => c.id === item.id);
          if (matchedCraft) {
            // 标记为选中
            this.$set(item, "select", true);
            this.$set(item, "isDefault", 1);
            
            // 设置文本内容
            if (matchedCraft.content) {
              this.$set(item, "value", matchedCraft.content);
            }
            
            // 添加到选中列表
            selectedItems.push(item);
          }
        } else {
          // 非叶子节点，递归处理
          item.children.forEach(child => processCraftItem(child));
        }
      };
      
      // 处理所有子项
      craft.children.forEach(child => processCraftItem(child));
      
      // 设置选择列表，确保不重复
      if (craft.chooseType === "CHECKBOX") {
        // 多选模式
        this.$set(craft, "selectCraftList", selectedItems);
      } else {
        // 单选模式，只保留第一个选中项
        if (selectedItems.length > 0) {
          craft.children.forEach(item => {
            if (item.id !== selectedItems[0].id) {
              this.$set(item, "select", false);
              this.$set(item, "isDefault", 0);
            }
          });
          
          this.$set(craft, "selectCraft", selectedItems[0]);
        }
      }
    },

    // 应用撞色选择
    applyContrastSelection(contrast, detail, category) {
      if (!detail.craftList || !detail.contrastSaveList || !contrast.children) return;
      
      contrast.children.forEach(child => {
        // 重置撞色选择列表
        if (!child.selectContrastList) {
          this.$set(child, "selectContrastList", []);
        } else {
          child.selectContrastList = [];
        }
        
        if (child.children) {
          // 查找选中的撞色项
          child.children.forEach(item => {
            const matchedContrast = detail.craftList.find(craft => craft.id === item.id);
            if (matchedContrast) {
              // 标记为选中
              this.$set(item, "select", true);
              this.$set(item, "isDefault", 1);
              
              // 添加到选中列表
              child.selectContrastList.push(item);
              
              // 处理撞色面料
              if (category.colorContrastFabric) {
                const matchedFabric = detail.contrastSaveList.find(c => c.site === item.id);
                if (matchedFabric) {
                  const fabric = category.colorContrastFabric.find(f => f.id === matchedFabric.color);
                  if (fabric) {
                    // 设置面料选中
                    this.$set(fabric, "select", true);
                    
                    // 设置文本内容
                    if (matchedFabric.content) {
                      this.$set(fabric, "value", matchedFabric.content);
                    }
                    
                    // 关联面料到撞色选项
                    this.$set(child, "selectContrastListFabric", fabric);
                  }
                }
              }
            }
          });
        }
      });
    },

    // 处理订单信息JSON
    processOrderInfoJson(orderInfoJson) {
      try {
        let orderInfo = JSON.parse(orderInfoJson);
        
        // 只处理非工艺相关的属性，保留现有工艺结构
        // 这避免了工艺数据被错误地重置或丢失
        this.$set(this, "params", orderInfo.params);
        this.$set(this, "standardChoose", orderInfo.standardChoose);
        this.$set(this, "styleList", orderInfo.styleList);
        this.$set(this, "isAddShow", orderInfo.isAddShow);
        this.$set(this, "specBodyParams", orderInfo.specBodyParams);
        
        // 更新clothing数据
        const newClothing = [];
        orderInfo.clothing.forEach(clothing => {
          if (clothing) {
            newClothing.push(JSON.parse(JSON.stringify(clothing)));
          }
        });
        this.$set(this, "clothing", newClothing);
        
        this.needGetStyleInfo = false;
      } catch (e) {
        console.error("解析订单信息失败:", e);
        this.needGetStyleInfo = true;
      }
    },

    // 更新所有工艺预览
    updateAllPreviews() {
      // 延迟执行，确保数据已经渲染
      this.$nextTick(() => {
        if(this.categroyMsg && this.categroyMsg.length > 0) {
          // 先清除所有预览选择，避免重复
          this.categroyMsg.forEach(category => {
            if(category.craft && category.craft.length > 0) {
              category.craft.forEach(craft => {
                if(craft.selectCraftList) {
                  this.$set(craft, "selectCraftList", []);
                }
              });
            }
            
            if(category.colorContrast && category.colorContrast.length > 0) {
              category.colorContrast.forEach(contrast => {
                if(contrast.children) {
                  contrast.children.forEach(child => {
                    if(child.selectContrastList) {
                      this.$set(child, "selectContrastList", []);
                    }
                  });
                }
              });
            }
          });
          
          // 然后再重新构建预览
          this.categroyMsg.forEach(category => {
            // 更新工艺预览
            if(category.craft && category.craft.length > 0) {
              category.craft.forEach(craft => {
                this.updateCraftPreview(craft);
              });
            }
            
            // 更新撞色预览
            if(category.colorContrast && category.colorContrast.length > 0) {
              category.colorContrast.forEach(contrast => {
                this.updateContrastPreview(contrast);
              });
            }
          });
          
          // 强制视图更新
          this.$forceUpdate();
        }
      });
    },
    // 编辑辅料
    editAccessories(e, s, accessories) {
      e.children.map((c) => {
        if (!c.children) {
          s.craftList.map((craft) => {
            if (craft.id == c.id) {
              accessories.selectCraft = c;
              accessories.selectCraft.value = craft.content;
              accessories.selectId = c.id;
            }
          });
        } else {
          this.editAccessories(c, s, accessories);
        }
      });
    },
    // 编辑工艺
    editCraft(e, s, crafts, deep) {
      // 首先检查e.children是否存在
      if (!e.children) return;
      
      // 查找订单中选中的工艺项
      const selectedCraftIds = s.craftList.map(craft => craft.id);
      
      // 检查是否有选中项
      const hasSelectedItems = e.children.some(child => selectedCraftIds.includes(child.id));
      
      // 遍历每个工艺子项
      e.children.map((c) => {
        // 重置默认选中状态，如果有订单选中项
        if (hasSelectedItems && c.isDefault === 1 && !selectedCraftIds.includes(c.id)) {
          this.$set(c, "isDefault", 0);
          this.$set(c, "select", false);
        }
        
        if (!c.children) {
          // 当前是叶子节点，检查是否在订单工艺列表中
          const matchedCraft = s.craftList.find(craft => craft.id == c.id);
          if (matchedCraft) {
            // 找到匹配的工艺，标记为选中
            if (deep) {
              // 多选场景
              // 确保selectCraftList已初始化
              if (!crafts.selectCraftList) {
                this.$set(crafts, "selectCraftList", []);
              }
              
              // 检查是否已经存在于selectCraftList中
              const dataArr = crafts.selectCraftList.filter((item) => {
                return item.id == matchedCraft.id;
              });
              
              if (dataArr.length == 0) {
                // 添加到多选列表
                this.$set(c, "select", true); // 标记为选中状态
                this.$set(c, "isDefault", 1); // 同时设置为默认，确保一致性
                crafts.selectCraftList.push(c);
                
                // 如果有内容值，设置到工艺项上
                if (matchedCraft.content) {
                  this.$set(c, "value", matchedCraft.content);
                }
              }
            } else {
              // 单选场景，先清除其他项的选中状态
              e.children.forEach(item => {
                if (item.id !== c.id) {
                  this.$set(item, "select", false);
                  this.$set(item, "isDefault", 0);
                }
              });
              
              // 设置当前项为选中
              this.$set(c, "select", true);
              this.$set(c, "isDefault", 1);
              e.selectCraft = c;
              
              // 如果有内容值，设置到工艺项上
              if (matchedCraft.content) {
                this.$set(c, "value", matchedCraft.content);
              }
            }
          }
        } else {
          // 存在子层级，递归处理
          if (!crafts.selectCraftList) {
            this.$set(crafts, "selectCraftList", []);
          }
          this.editCraft(c, s, crafts, "deep");
        }
      });
      
      // 更新左侧预览的selectCraftList，确保显示正确的选中项
      if (!deep) {
        // 重新构建selectCraftList
        this.updateCraftPreview(crafts);
      }
    },
    // 更新工艺预览显示
    updateCraftPreview(craftItem) {
      if (!craftItem) return;
      
      // 清空当前selectCraftList
      if (!craftItem.selectCraftList) {
        this.$set(craftItem, "selectCraftList", []);
      } else {
        craftItem.selectCraftList = [];
      }
      
      // 找出所有select为true或isDefault为1的项目
      const findSelectedItems = (children) => {
        if (!children) return [];
        
        let selected = [];
        children.forEach(child => {
          if (child.select === true || child.isDefault === 1) {
            // 检查是否已经添加过相同ID的项目，避免重复
            if (!selected.some(item => item.id === child.id)) {
              selected.push(child);
            }
          }
          
          if (child.children && child.children.length > 0) {
            const childSelected = findSelectedItems(child.children);
            // 合并子级选中项，避免重复
            childSelected.forEach(item => {
              if (!selected.some(s => s.id === item.id)) {
                selected.push(item);
              }
            });
          }
        });
        
        return selected;
      };
      
      // 更新selectCraftList
      const selectedItems = findSelectedItems(craftItem.children);
      if (selectedItems.length > 0) {
        craftItem.selectCraftList = selectedItems;
      }
      
      // 如果是单选模式，还需要确保selectCraft设置正确
      if (craftItem.chooseType === "RADIO" && selectedItems.length > 0) {
        craftItem.selectCraft = selectedItems[0];
      }
    },
    // 编辑撞色
    editColorContrast(e, s, crafts, colorContrastFabrics, deep) {
      // 初始化选中列表
      if (!e.selectContrastList) {
        this.$set(e, "selectContrastList", []);
      } else {
        // 清空当前选中列表，避免重复
        e.selectContrastList = [];
      }
      
      // 获取订单中的撞色选择项ID
      const selectedContrastIds = s.craftList
        .filter(craft => s.contrastSaveList.some(contrast => contrast.site === craft.id))
        .map(craft => craft.id);
      
      // 检查是否有选中项
      const hasSelectedItems = e.children.some(child => selectedContrastIds.includes(child.id));
      
      // 遍历撞色选项
      e.children.map((c) => {
        // 重置默认选中状态，如果有订单选中项且当前项不在选中列表中
        if (hasSelectedItems && c.isDefault === 1 && !selectedContrastIds.includes(c.id)) {
          this.$set(c, "isDefault", 0);
          this.$set(c, "select", false);
        }
        
        if (!c.children) {
          // 查找订单中是否有匹配的撞色选择
          const matchedContrast = s.craftList.find(craft => craft.id == c.id);
          if (matchedContrast) {
            // 检查是否为单选模式
            if (e.chooseType !== "CHECKBOX") {
              // 单选模式，先清除同组其他项的选中状态
              e.children.forEach(item => {
                if (item.id !== c.id) {
                  this.$set(item, "select", false);
                  this.$set(item, "isDefault", 0);
                }
              });
            }
            
            // 标记为选中状态
            this.$set(c, "select", true);
            this.$set(c, "isDefault", 1);
            
            // 确保不重复添加到selectContrastList
            if (!e.selectContrastList.some(item => item.id === c.id)) {
              e.selectContrastList.push(c);
            }
            
            // 查找对应的撞色面料
            if (colorContrastFabrics && colorContrastFabrics.colorContrastFabric) {
              // 尝试找到对应的面料记录
              const matchedFabric = s.contrastSaveList.find(contrast => contrast.site == c.id);
              if (matchedFabric) {
                // 找到对应的面料对象
                const fabric = colorContrastFabrics.colorContrastFabric.find(
                  f => f.id == matchedFabric.color
                );
                
                if (fabric) {
                  // 先清除其他面料的选中状态
                  colorContrastFabrics.colorContrastFabric.forEach(f => {
                    this.$set(f, "select", f.id === fabric.id);
                  });
                  
                  // 设置选中状态
                  this.$set(fabric, "select", true);
                  // 设置文本内容（如果有）
                  if (matchedFabric.content) {
                    this.$set(fabric, "value", matchedFabric.content);
                  }
                  // 关联面料到撞色选项
                  this.$set(e, "selectContrastListFabric", fabric);
                }
              }
            }
          }
        } else {
          // 递归处理子级
          if (!crafts.selectContrastList) {
            this.$set(crafts, "selectContrastList", []);
          }
          this.editColorContrast(c, s, crafts, colorContrastFabrics, "deep");
        }
      });
      
      // 更新左侧撞色预览
      if (!deep && colorContrastFabrics) {
        this.updateContrastPreview(colorContrastFabrics);
      }
    },

    // 更新撞色预览显示
    updateContrastPreview(contrastItem) {
      if (!contrastItem || !contrastItem.children) return;
      
      // 处理每个撞色子项
      contrastItem.children.forEach(child => {
        // 清空当前selectContrastList
        if (!child.selectContrastList) {
          this.$set(child, "selectContrastList", []);
        } else {
          child.selectContrastList = [];
        }
        
        // 找出所有select为true或isDefault为1的项并去重
        if (child.children) {
          const selectedItems = [];
          child.children.forEach(item => {
            if (item.select === true || item.isDefault === 1) {
              // 检查是否已存在相同ID的项目
              if (!selectedItems.some(existItem => existItem.id === item.id)) {
                selectedItems.push(item);
              }
            }
          });
          
          // 更新选中列表
          child.selectContrastList = selectedItems;
          
          // 强制更新视图
          this.$forceUpdate();
        }
      });
    },
    // 英寸转厘面
    cms() {
      this.clothing.map((item) => {
        item.sizeList.map((sitem) => {
          if (
            this.specBodyParams.sizeType == 10052 ||
            this.specBodyParams.sizeType == 10053
          ) {
            //如果是净体
            if (!this.noChange) {
              if (sitem.inputValue) {
                sitem.inputValue = Number(
                  inchToCom(sitem.inputValue).toFixed(2)
                );
              }
            } else {
              if (sitem.inputValue) {
                sitem.inputValue = sitem.inputValue;
              }
            }
          }
          if (!this.noChangeEdit) {
            sitem.minValue = Number(inchToCom(sitem.minValue).toFixed(2));
            sitem.maxValue = Number(inchToCom(sitem.maxValue).toFixed(2));
          }
        });
      });
      this.noChange = false;
      this.noChangeEdit = false;
    },
    // 英寸转厘面
    cmsAll() {
      if (!this.nochangeBzh) {
        this.clothing.map((aitem) => {
          aitem.standardList.map((item) => {
            item.details.map((sitem) => {
              sitem.inputValue = Number(inchToCom(sitem.inputValue).toFixed(2));
              sitem.defaultValue = Number(
                inchToCom(sitem.defaultValue).toFixed(2)
              );
              sitem.minValue = Number(inchToCom(sitem.minValue).toFixed(2));
              sitem.maxValue = Number(inchToCom(sitem.maxValue).toFixed(2));
            });
          });
          this.$forceUpdate();
        });
      }
      this.nochangeBzh = false;
    },
    // 厘米转英寸
    inchsAll() {
      if (!this.nochangeBzh) {
        this.clothing.map((aitem) => {
          aitem.standardList.map((item) => {
            item.details.map((sitem) => {
              sitem.defaultValue = Number(
                cmToInch(sitem.defaultValue).toFixed(2)
              );
              sitem.inputValue = Number(cmToInch(sitem.inputValue).toFixed(2));
              sitem.minValue = Number(cmToInch(sitem.minValue).toFixed(2));
              sitem.maxValue = Number(cmToInch(sitem.maxValue).toFixed(2));
            });
          });
          this.$forceUpdate();
        });
      }
      this.nochangeBzh = false;
    },
    // 厘米转英寸
    inchs() {
      this.clothing.map((item) => {
        item.sizeList.map((sitem) => {
          if (
            this.specBodyParams.sizeType == 10052 ||
            this.specBodyParams.sizeType == 10053
          ) {
            //如果是净体
            if (!this.noChange) {
              if (sitem.inputValue) {
                sitem.inputValue = Number(
                  cmToInch(sitem.inputValue).toFixed(2)
                );
              }
            } else {
              if (sitem.inputValue) {
                sitem.inputValue = sitem.inputValue;
              }
            }
          }
          if (!this.noChangeEdit) {
            sitem.minValue = Number(cmToInch(sitem.minValue).toFixed(2));
            sitem.maxValue = Number(cmToInch(sitem.maxValue).toFixed(2));
          }
        });
      });
      this.noChange = false;
      this.noChangeEdit = false;
    },
    //修改量体方式
    changeTailored(e) {
      // console.log("e", e);
      if (e === 10052 || e === 10053) {
        this.measureInfo("");
      } else {
        this.clothing.map((citem) => {
          citem.sizeList = [];
          // citem.standardList = []
        });
      }
      this.specBodyParams.sizeType = e;
      // console.log("this.standardList", this.standardList);
      if (this.standardList && this.standardList.length > 0) {
        this.standardChoose.id = this.standardList[0].id;
        this.standardChoose.property = this.standardList[0].property;
      }
      this.specBody(); //特体信息
    },
    handleChildExtension(children, middleObj) {
      children.map((item) => {
        if (item.children && item.children.length > 0) {
          this.handleChildExtension(item.children, middleObj);
        } else {
          if (item.isDefault === 1 && item.extension) {
            middleObj.hasxtension = true;
            this.handleReviseSzieList(item);
          }
        }
      });
    },
    // 尺码类型
    standard() {
      this.standardAction({
        category: this.productId,
      }).then((res) => {
        this.standardList = res.data;
      });
    },
    // 长短袖
    handleReviseSzieList(craftData) {
      let showSize = null;
      let hideSize = null;
      let categoryCode = craftData.code.split("_")[0];
      if (!craftData.extension) {
        return false;
      }
      let sizes = craftData.extension.split("|");
      // 净体
      if (this.specBodyParams.sizeType === 10052) {
        showSize = sizes[0].split("&")[0] || "";
        hideSize = sizes[0].split("&")[1] || "";
        // 成衣
      } else if (this.specBodyParams.sizeType !== 10052) {
        showSize = sizes[1].split("&")[0];
        hideSize = sizes[1].split("&")[1];
      }
      if (this.specBodyParams.sizeType !== 10054) {
        let currentItem = this.clothing.find((item) => {
          return item.id === Number(categoryCode);
        });
        currentItem.sizeList.map((item) => {
          this.$set(item, "disabled", false);
          let hasSize = hideSize.includes(item.id);
          if (hasSize) {
            this.$set(item, "disabled", true);
          }
        });
      } else {
        let currentSize = this.clothing.find((item) => {
          return item.id === Number(categoryCode);
        });
        currentSize.standardList.find((item) => {
          item.details.map((ditem) => {
            this.$set(ditem, "disabled", false);
            let hasSize = hideSize.includes(ditem.id);
            if (hasSize) {
              this.$set(ditem, "disabled", true);
            }
          });
        });
      }
    },
    // 特提信息
    specBody() {
      this.zzSpecBodyAction(this.specBodyParams).then((res) => {
        if (res.data) {
          res.data.map((item) => {
            item.chooseId = "";
          });
          this.styleList = res.data;
          this.styleList.map((item) => {
            if (item.chooseId) return false;
            let normalItem = item.details.find(
              (dItem, dIIndex) => dIIndex === 0
            );
            this.$set(item, "chooseId", normalItem.id);
          });
          this.chooseStyleMsg = {
            chooseStyleImg: "",
            chooseStyleContent: "",
          };
        } else {
          this.styleList = [];
          this.chooseStyleMsg = {
            chooseStyleImg: "",
            chooseStyleContent: "",
          };
        }
      });
    },

    // 选号型
    measureInfo(shapeCategory) {
      // console.log(123)
      this.shapeCategory = shapeCategory;
      this.measureInfoAction({
        category: this.productId,
        measureType: this.specBodyParams.sizeType,
        shapeCategory: shapeCategory,
        customerId:
          this.specBodyParams.sizeType === 10054
            ? ""
            : this.submitOrder.customerId,
        type: 7,
      }).then((res) => {
        res.data.map((item) => {
          this.clothing.map((citem) => {
            if (item.id == citem.id) {
              if (this.specBodyParams.sizeType == 10054) {
                // console.log("this.queryOrderId", this.queryOrderId);
                // if (!this.queryOrderId) {
                if (this.needGetStyleInfo) {
                  citem.standardList = item.sizeList;
                  citem.sizeList = item.sizeList[0].details;
                  citem.chosoeId = item.sizeList[0].id;
                }
                this.queryOrderId = "";
                item.sizeList.map((aitem) => {
                  if (this.customerDetails.heightUnit == 10266) {
                    aitem.details.map((ditem) => {
                      ditem.inputValue = JSON.parse(
                        JSON.stringify(ditem.defaultValue)
                      );
                      ditem.addNum = 0.5;
                    });
                  } else {
                    aitem.details.map((ditem) => {
                      ditem.minValue = Number(
                        cmToInch(ditem.minValue).toFixed(2)
                      );
                      ditem.maxValue = Number(
                        cmToInch(ditem.maxValue).toFixed(2)
                      );
                      if (ditem.defaultValue != undefined) {
                        ditem.defaultValue = cmToInch(
                          ditem.defaultValue
                        ).toFixed(2);
                      }
                      ditem.inputValue = JSON.parse(
                        JSON.stringify(ditem.defaultValue)
                      );
                      ditem.addNum = 0.5;
                    });
                  }
                });
              } else {
                citem.standardList = [];
                // 尺寸换算
                item.sizeList.map((sitem) => {
                  if (this.customerDetails.heightUnit == 10266) {
                    // 单位是厘米
                    if (item.sizeUnit === 10266) {
                      sitem.inputValue = sitem.inputValue;
                    } else {
                      if (sitem.inputValue != undefined) {
                        sitem.inputValue = inchToCom(sitem.inputValue).toFixed(
                          2
                        );
                      }
                    }
                    // 单位是英寸
                  } else {
                    sitem.minValue = Number(
                      cmToInch(sitem.minValue).toFixed(2)
                    );
                    sitem.maxValue = Number(
                      cmToInch(sitem.maxValue).toFixed(2)
                    );

                    if (item.sizeUnit === 10266) {
                      if (sitem.inputValue != undefined) {
                        sitem.inputValue = cmToInch(sitem.inputValue).toFixed(
                          2
                        );
                      }
                    }
                  }
                });
                citem.sizeList = item.sizeList;
              }
            }
          });
        });
        this.handleHasExtension();
        if (this.specBodyParams.sizeType == 10052) {
          // this.preSubmit()
          this.isPreSubmit = false;
        }
      });
    },
    // 替换
    replaceChildren(children, changeList, changeChildIdsList) {
      children.map((citem) => {
        if (changeList.indexOf(citem.code) != -1) {
          if (changeChildIdsList.indexOf(citem.childIds) == -1) {
            /*替换*/
            if (!citem.copyChildren || citem.copyChildren.length == 0) {
              citem.children.map((pitem) => {
                pitem.isDefault = 0;
              });
              citem.copyChildren = JSON.parse(JSON.stringify(citem.children));
            }
            citem.childIds =
              this.replaceCraft[changeList.indexOf(citem.code)].childIds;
            citem.children =
              this.replaceCraft[changeList.indexOf(citem.code)].children;
            this.craftSelectSpliceCopy(citem, changeList);
          }
        } else {
          if (citem.copyChildren && citem.copyChildren.length > 0) {
            citem.children = JSON.parse(JSON.stringify(citem.copyChildren));
          }
          citem.childIds = "";
          citem.copyChildren = [];
        }
        if (citem.children && citem.children.length > 0) {
          this.replaceChildren(citem.children, changeList, changeChildIdsList);
        }
      });
    },
    handleChildExtension(children, middleObj) {
      children.map((item) => {
        if (item.children && item.children.length > 0) {
          this.handleChildExtension(item.children, middleObj);
        } else {
          if (item.isDefault === 1 && item.extension) {
            middleObj.hasxtension = true;
            this.handleReviseSzieList(item);
          }
        }
      });
    },
    // 选择工艺处理工艺
    craftSelect(e, config) {
      // console.log("craftSelect", 123, e, config);
      // 将当前级别跟下级一块填充
      let changesMsg = "";
      this.categroyMsg.map((item, index) => {
        if (item.id == config.code.split("_")[0]) {
          changesMsg = item;
        }
      });
      if (e.isDefault == 1) {
        changesMsg.craftChooseList.push(e.code);
        if (e.children && e.children.length > 0) {
          e.children.map((citem) => {
            if (citem.isDefault == 1) {
              this.craftSelect(citem, config);
            }
          });
        }
        config.children.map((ccitem, ccindex) => {
          if (
            changesMsg.craftChooseList.indexOf(ccitem.code) != -1 &&
            ccitem.isDefault == 0
          ) {
            changesMsg.craftChooseList.splice(
              changesMsg.craftChooseList.indexOf(ccitem.code),
              1
            );
            if (ccitem.children && ccitem.children.length > 0) {
              this.craftSelectSplice(ccitem, changesMsg);
            }
          }
        });
      } else if (e.isDefault == 0) {
        let index = changesMsg.craftChooseList.indexOf(e.code);
        changesMsg.craftChooseList.splice(index, 1);
        if (e.children && e.children.length > 0) {
          e.children.map((citem) => {
            if (citem.isDefault == 1) {
              this.craftSelectSplice(citem, changesMsg);
            }
          });
        }
      }
      let params = {
        category: e.code.split("_")[0],
        craftIds: "",
      };
      // console.log("changesMsg", changesMsg);
      this.searchCraft(changesMsg.craftChooseList, params);
      this.handleHasExtension(e);
    },
    handleHasExtension() {
      let middleObj = {
        hasxtension: false,
      };
      this.categroyMsg.map((item) => {
        item.craftList.map((citem) => {
          if (citem.children && citem.children.length > 0) {
            this.handleChildExtension(citem.children, middleObj);
          }
        });
      });
      if (!middleObj.hasxtension) {
        this.categroyMsg.map((item) => {
          item.craftList.map((citem) => {
            if (citem.children && citem.children.length > 0) {
              this.handleResetDisabled();
            }
          });
        });
      }
    },
    handleResetDisabled() {
      if (this.specBodyParams.sizeType !== 10054) {
        this.clothing.map((item) => {
          item.sizeList.map((sitem) => {
            this.$set(sitem, "disabled", false);
          });
        });
      } else {
        this.clothing.map((item) => {
          item.standardList.map((sitem) => {
            sitem.details.map((ditem) => {
              this.$set(ditem, "disabled", false);
            });
          });
        });
      }
    },
    // 选号型
    changeSizeId(e) {
      this.standardChoose = e;
      this.measureInfo(this.standardChoose.sizeId);
    },
    // 选尺码类型
    changeStandard(e) {
      this.standardChoose = e;
    },
    // 编辑使用
    changeEditOnce() {
      this.editOnce = false;
    },
    // 第三步方法--end
    // 获得量体方式
    listDictSystem() {
      if (this.tailoredList.length == 0) {
        this.listDictSystemAction({
          category: 13,
        }).then((res) => {
          this.tailoredList = res.data;
          if (this.needGetStyleInfo) {
            let sizeId = res.data.filter((f) => {
              return f.id == 10053;
            });
            if (sizeId && sizeId.length > 0) {
              this.specBodyParams.sizeType = sizeId[0].id;
            } else {
              this.specBodyParams.sizeType = res.data[0].id;
              this.$message.error(
                "Pls presubmit for finished measurements first"
              );
            }
            this.changeTailored(this.specBodyParams.sizeType);
          }
        });
      }
    },
      // 选择撞色部位
  chooseContrast(pitem, contrast) {
    if (contrast.chooseType == "CHECKBOX") {
      //多选
      this.$set(pitem, "select", Boolean(!pitem.select));
    } else {
      //单选
      // 先清除所有选项的选中状态
      contrast.children.forEach(item => {
        if (item.id !== pitem.id) {
          this.$set(item, "select", false);
          this.$set(item, "isDefault", 0);
        }
      });
      // 设置当前项为选中
      this.$set(pitem, "select", true);
      this.$set(pitem, "isDefault", 1);
    }
    
    // 更新选中列表，确保不重复
    this.$set(contrast, "selectContrastList", []);
    const selectedItems = [];
    contrast.children.forEach(s => {
      if (s.select) {
        // 检查是否已存在相同ID的项目
        if (!selectedItems.some(item => item.id === s.id)) {
          selectedItems.push(s);
        }
      }
    });
    contrast.selectContrastList = selectedItems;
  },
    // 选择撞色面料
    chooseContrastFabric(pitem, contrast) {
      // 清除所有面料选择
      this.showColorContrast.colorContrastFabric.forEach(item => {
        this.$set(item, "select", item.id === pitem.id ? !item.select : false);
      });
      
      // 更新选中状态
      if (pitem.select) {
        this.$set(contrast, "selectContrastListFabric", pitem);
        contrast.selectContrastListFabric = pitem;
      } else {
        this.$set(contrast, "selectContrastListFabric", null);
      }
    },
    focusFabric(pitem, contrast) {
      // 清除所有面料选择
      this.showColorContrast.colorContrastFabric.forEach(item => {
        this.$set(item, "select", item.id === pitem.id);
      });
      
      // 更新选中状态
      this.$set(contrast, "selectContrastListFabric", pitem);
      contrast.selectContrastListFabric = pitem;
    },
    // 删除刺绣
    delEmb(index) {
      this.$Modal.confirm({
        title: this.$t("delMsg.tips"),
        content: this.$t("delMsg.content"),
        okText: this.$t("delMsg.y"),
        cancelText: this.$t("delMsg.n"),
        onOk: async () => {
          this.showEmb.embList.splice(index, 1);
        },
      });
    },
    changePosition(e, embItem) {
      embItem.siteName = e.label;
      // console.log("e", e, embItem);
    },
    // 搜索颜色
    queryChangeColor(e, parent, embItem) {
      if (embItem.searchColor && embItem.searchColor.length > 0 && !e) {
        return;
      }
      this.zzEmbAction({
        category: parent.id,
        type: "emb_color",
        keywords: e,
      }).then((res) => {
        // res.data.map((item) => {
        //   item.isDefault = 0;
        // });
        embItem.searchColor = res.data;
      });
    },
    clearColor(e, parent, embItem) {
      this.zzEmbAction({
        category: parent.id,
        type: "emb_color",
        keywords: "",
      }).then((res) => {
        // res.data.map((item) => {
        //   item.isDefault = 0;
        // });
        embItem.searchColor = res.data;
      });
    },
    // 修改选中颜色
    changeColor(e, parent) {
    },
    // 修改选中尺码
    changeSize(e, parent) {
    },
    // 搜索字体
    queryChangeFont(e, parent, embItem) {
      if (embItem.searchFont && embItem.searchFont.length > 1 && !e) {
        return;
      }
      this.zzEmbAction({
        category: parent.id,
        type: "emb_font",
        keywords: e,
      }).then((res) => {
        // res.data.map((item) => {
        //   item.isDefault = 0;
        // });
        embItem.searchFont = res.data;
      });
    },
    clearFont(e, parent, embItem) {
      this.zzEmbAction({
        category: parent.id,
        type: "emb_font",
        keywords: "",
      }).then((res) => {
        // res.data.map((item) => {
        //   item.isDefault = 0;
        // });
        embItem.searchFont = res.data;
      });
    },
    // 搜索字体
    queryChangeSize(e, parent, embItem) {
      if (embItem.searchSize && embItem.searchSize.length > 1 && !e) {
        return;
      }
      this.zzEmbAction({
        category: parent.id,
        type: "emb_size",
        keywords: e,
      }).then((res) => {
        // res.data.map((item) => {
        //   item.isDefault = 0;
        // });
        embItem.searchSize = res.data;
        // console.log(res.data, e, parent, embItem);
      });
    },
    // 搜索字体
    clearSize(e, parent, embItem) {
      this.zzEmbAction({
        category: parent.id,
        type: "emb_size",
        keywords: "",
      }).then((res) => {
        // res.data.map((item) => {
        //   item.isDefault = 0;
        // });
        embItem.searchSize = res.data;
        // console.log(res.data, e, parent, embItem);
      });
    },
    // 修改选中字体
    changeFont(e, parent) {
    },
    // 选择辅料
    changeAccessories(e, aitem) {
      // console.log(e, aitem);
      aitem.children.map((accessories) => {
        if (accessories.id == e) {
          this.$set(aitem, "selectCraft", accessories);
        }
      });
    },
    // 选择刺绣
    chooseEmb(e) {
      // console.log(e);
      this.showCraft = "";
      this.showColorContrast = "";
      this.showEmb = e;
      this.type = "emb";
      // this.showCraft.embList = []
      // this.showCraft.embList.push(this.embMsg)
    },
    // 选择的工艺
    chooseCraft(e) {
      // console.log("e", e);
      this.showCraft = e;
      this.showEmb = "";
      this.showColorContrast = "";
      this.type = "craft";
    },
    // 选择撞色
    chooseColorContrast(e) {
      // console.log("e", e);
      this.showCraft = "";
      this.showEmb = "";
      this.showColorContrast = e;
      this.type = "colorContrast";
    },
    // 修改特体
    changeStyle(item, litem) {
      item.chooseId = litem.id;
      this.chooseStyleMsg.chooseStyleImg = litem.imagePath;
      this.chooseStyleMsg.chooseStyleContent = litem.description;
    },
    // 修改品类清空
    changeProduct(e) {
      // console.log("e", e);
      this.stepId = 1;
      this.specBodyParams.category = e;
      if (this.$route.query.orderId) {
        this.getCraft(e);
      } else {
        this.getCraft(e, "active");
      }
      this.showCraft = "";
      this.type = "";
      this.showEmb = "";
      this.showColorContrast = "";
      this.tailoredList = [];
      this.getStyleInfo();
      this.categoryMessage = this.product.filter((s) => {
        return s.id == e;
      })[0];
      // this.product.filter(s=>{
      //   if(s.id==e){
      //     // console.log(s.ecode.split('')[0])
      //     if(s.ecode.split('')[0]=='W'){
      //       this.submitOrder.genderId =  10041
      //     }else{
      //       this.submitOrder.genderId = 10040
      //     }
      //   }
      // })

      // this.listDictSystem()
      // this.measureInfo("")
    },
    addEmb() {
      const newEmb = JSON.parse(JSON.stringify(this.embMsg));
      
      // 如果有默认选项，设置默认值
      if (this.showEmb.emb && this.showEmb.emb.length > 0) {
        const defaultEmb = this.showEmb.emb[0];
        newEmb.site = defaultEmb.id;
        newEmb.siteName = defaultEmb.name;
      }
      
      this.showEmb.embList.push(newEmb);
      console.log("this.showEmb", JSON.stringify(this.showEmb));
    },
      chooseCraftOne(e) {
    if (this.showCraft.chooseType == "CHECKBOX") {
      // 多选模式
      this.$set(e, "select", Boolean(!e.select));
    } else {
      // 单选模式
      this.showCraft.children.map((s) => {
        // 将所有项设置为非选中状态
        this.$set(s, "select", false);
        // 同时清除默认选中状态
        this.$set(s, "isDefault", 0);
      });
      // 设置当前项为选中状态
      this.$set(e, "select", true);
      // 同时设置为默认状态
      this.$set(e, "isDefault", 1);
    }
    
    // 更新选中列表，确保不重复
    this.$set(this.showCraft, "selectCraftList", []);
    const selectedItems = [];
    
    this.showCraft.children.forEach((s) => {
      if (s.select) {
        // 检查是否已存在相同ID的项
        if (!selectedItems.some(item => item.id === s.id)) {
          selectedItems.push(s);
        }
      }
    });
    
    this.showCraft.selectCraftList = selectedItems;
    this.craftSelect(e, this.showCraft);
  },
      focusCraftAny(e, yitem) {
    if (yitem.chooseType == "CHECKBOX") {
      // 多选模式
      this.$set(e, "select", Boolean(!e.select));
    } else {
      // 单选模式
      yitem.children.map((s) => {
        // 将所有项设置为非选中状态
        this.$set(s, "select", false);
        // 同时清除默认选中状态
        this.$set(s, "isDefault", 0);
      });
      // 设置当前项为选中状态
      this.$set(e, "select", true);
      // 同时设置为默认状态
      this.$set(e, "isDefault", 1);
    }
    
    // 更新选中列表，确保不重复
    this.$set(this.showCraft, "selectCraftList", []);
    const selectedItems = [];
    
    this.showCraft.children.forEach((y) => {
      y.children.forEach((s) => {
        if (s.select) {
          // 检查是否已存在相同ID的项
          if (!selectedItems.some(item => item.id === s.id)) {
            selectedItems.push(s);
          }
        }
      });
    });
    
    this.showCraft.selectCraftList = selectedItems;
    this.craftSelect(e, yitem);
  },
      chooseCraftAny(e, yitem) {
    if (yitem.chooseType == "CHECKBOX") {
      // 多选模式
      this.$set(e, "select", Boolean(!e.select));
    } else {
      // 单选模式
      yitem.children.map((s) => {
        // 将所有项设置为非选中状态
        this.$set(s, "select", false);
        // 同时清除默认选中状态
        this.$set(s, "isDefault", 0);
      });
      // 设置当前项为选中状态
      this.$set(e, "select", !e.select);
      // 同时设置为默认状态
      if (e.select) {
        this.$set(e, "isDefault", 1);
      }
    }
    
    // 更新选中列表，确保不重复
    this.$set(this.showCraft, "selectCraftList", []);
    const selectedItems = [];
    
    this.showCraft.children.forEach((y) => {
      y.children.forEach((s) => {
        if (s.select) {
          // 检查是否已存在相同ID的项
          if (!selectedItems.some(item => item.id === s.id)) {
            selectedItems.push(s);
          }
        }
      });
    });
    
    this.showCraft.selectCraftList = selectedItems;
    this.craftSelect(e, yitem);
  },

    // 工艺子集在父级赋值
    setParentIds(parent) {
      parent.childIds = "";
      parent.children.map((item) => {
        parent.childIds = parent.childIds + item.id + ",";
        if (item.children) {
          this.setParentIds(item);
        }
      });
    },
    // 递归插入已选择的id
    craftForChoose(e, item) {
      // console.log("e", e.isDefault);
      if (e.isDefault == 1) {
        // console.log("e", e);
        item.craftChooseList.push(e.code);
        if (
          (e.isDefault == 1 || e.sourceType == "LABEL") &&
          e.children &&
          e.children.length > 0
        ) {
          e.children.map((citem, cindex) => {
            this.craftForChoose(citem, item);
          });
        }
      }
    },
    // 默认值赋值
    handSearchCraftCraftIds(citem, item) {
      if (citem.children && citem.children.length > 0) {
        this.$set(citem, "selectCraftList", []);
        citem.children.map((mitem) => {
          if (mitem.children && mitem.children.length > 0) {
            // this.handSearchCraftCraftIds(mitem, item);
            // console.log(2558,mitem.children)
            mitem.children.map((m) => {
              if (m.isDefault == 1) {
                m.select = true;
                citem.selectCraftList.push(m);
              }
            });
          } else {
            if (mitem.isDefault == 1) {
              // console.log("mitem", mitem.name, citem);
              item.craftChooseList.push(mitem.code);
              // selectCraft
              mitem.select = true;
              this.$set(citem, "selectCraftList", [mitem]);
              // console.log('mitem',mitem,citem)
            }
          }
        });
      } else {
        if (citem.isDefault == 1 && citem.sourceType != "LABEL") {
          item.craftChooseList.push(citem.code);
        }
      }
    },
    // 默认值赋值
    handSearchCraftCraftIdss(citem, item) {
      // console.log(174666666666, citem.sourceType, citem.name, citem);
      if (citem.children && citem.children.length > 0) {
        citem.children.map((mitem) => {
          if (mitem.isDefault == 1) {
            this.$set(citem, "selectCraft", mitem);
            this.$set(citem, "selectId", mitem.id);
          }
          if (mitem.children && mitem.children.length > 0) {
            this.handSearchCraftCraftIdss(mitem, item);
          }
        });
      } else {
        if (citem.isDefault == 1 && citem.sourceType != "LABEL") {
          item.craftChooseList.push(citem.code);
        }
      }
    },
    // 获取工艺
    getCraft(e, active) {
      this.zzCraftAction({category: e}).then((res) => {
        // console.log("res", res);
        this.product.filter((s) => {
          if (s.id == e) {
            // console.log(s.ecode.split('')[0])
            if (s.ecode.split("")[0] == "W") {
              this.submitOrder.genderId = 10041;
            } else {
              this.submitOrder.genderId = 10040;
            }
          }
        });
        this.clothing = [];
        if (res.data.length == 0) {
          return;
        }
        res.data.map((item, cloindex) => {
          // 第三步数据赋值
          this.clothing.push({
            id: item.id,
            enName: item.enName,
            name: item.name,
            // styleId: "",
            chooseStyleId: "",
            sizeList: [],
            standardList: [],
            styleList: [],
          });
          // this.rightDetails.detailList.push({
          //   clothCategory: item.id,
          //   url: item.urlPath,
          //   name: item.name,
          //   embList: [], //刺绣
          //   craftList: [], //工艺及辅料
          //   colorContrast: [], //撞色
          // });
          item.craft = []; //工艺
          item.emb = []; //刺绣
          item.embList = []; //选取的刺绣
          item.accessories = []; //辅料
          item.colorContrast = []; //撞色
          item.craftChooseList = []; //当前选中的craftId
          Promise.all([
            // 刺绣颜色
            this.zzEmbAction({
              category: item.id,
              type: "emb_color",
              keywords: "",
            }).then((res) => {
              res.data.map((item) => {
                item.isDefault = 0;
              });
              item.embColor = res.data;
            }),
            // 刺绣尺寸
            this.zzEmbAction({
              category: item.id,
              type: "emb_size",
              keywords: "",
            }).then((res) => {
              if (res.data.length > 0) {
                this.showEmbSize = true;
              } else {
                this.showEmbSize = false;
              }
              res.data.map((item) => {
                item.isDefault = 0;
              });
              item.embSize = res.data;
            }),
            // 撞色
            this.zzContrastAction({
              category: item.id,
              keywords: "",
            }).then((res) => {
              res.data.map((item) => {
                item.isDefault = 0;
              });
              item.colorContrastFabric = res.data;
            }),
            // 刺绣文字
            this.zzEmbAction({
              category: item.id,
              type: "emb_font",
              keywords: "",
            }).then((res) => {
              res.data.map((item) => {
                item.isDefault = 0;
              });
              item.embFont = res.data;
            }),
          ]).then((result) => {
            if (item.craftList.length == 0) {
              return;
            }
            item.craftList.map((citem) => {
              if (citem.children && citem.children.length > 0) {
                this.setParentIds(citem);
              }
              if (citem.category == 1) {
                //1为工艺
                item.craft.push(citem);
                // 查看是否存在默认工艺 赋值已选择的id
                this.craftForChoose(citem, item);

                this.handSearchCraftCraftIds(citem, item);
              } else if (citem.category == 2) {
                //2为刺绣
                // console.log("刺绣", citem.children[0].children);
                if (
                  citem.children[0].children &&
                  citem.children[0].children.length > 0
                ) {
                  citem.children[0].children.map((eitem) => {
                    // 刺绣详情信息赋值便于储存刺绣位置信息
                    this.$set(
                      eitem,
                      "embContent",
                      JSON.parse(JSON.stringify(this.embContent))
                    );
                    this.$set(eitem, "check", false);
                    eitem.embFont = JSON.parse(JSON.stringify(item.embFont));
                    eitem.embColor = JSON.parse(JSON.stringify(item.embColor));
                    eitem.embSize = JSON.parse(JSON.stringify(item.embSize));
                  });
                  this.$set(item, "emb", citem.children[0].children);
                }
              } else if (citem.category == 3) {
                //3为辅料
                // this.craftForChoose(citem, item);
                // console.log("衬类型", citem.children[0].sourceType);
                this.handSearchCraftCraftIdss(citem, item);

                if (citem.children[0].sourceType == "LABEL") {
                  citem.children.map((s) => {
                    item.accessories.push(s);
                  });
                  // item.accessories.concat(citem.children)
                  // console.log('citem.children',citem.children)
                } else {
                  item.accessories.push(citem);
                }
              } else if (citem.category == 4) {
                //撞色
                // console.log("撞色", citem);
                this.$set(item, "colorContrast", []);
                this.$set(
                  citem,
                  "colorContrastFabric",
                  item.colorContrastFabric
                );
                // citem.colorContrastFabric = item.colorContrastFabric
                item.colorContrast.push(citem);
                // citem.children[0].children.map((contrastItem) => {
                //   this.$set(contrastItem, "check", false);
                //   this.$set(contrastItem, "chooseFabric", "");
                //   this.$set(contrastItem, "chooseFabricCode", "");
                // });
                // citem.children[0].children.map((eitem) => {
                //   this.$set(
                //     eitem,
                //     "colorContrastFabric",
                //     JSON.parse(JSON.stringify(item.colorContrastFabric))
                //   );
                // });
                // this.$set(item, "colorContrast", citem.children[0].children);
              }
            });
          });
        });
        console.log("获取的工艺", res.data);
        this.categroyMsg = res.data;
        
        // 处理默认工艺冲突
        this.handleDefaultCraftConflicts();
        
        if (this.$route.query.orderId && !active) {
          this.editOrder();
          // this.needGetStyleInfo = false
        } else {
          this.needGetStyleInfo = true;
        }
        // console.log("this.categroyMsg", this.categroyMsg);
      });
    },
    // 选择客户
    chooseCustomer(e) {
      this.bodyList = e.customerSizeList;
      this.cySizeList = e.cySizeList;
      // this.bodyList = custInfo.bodyList;
      if (e.customerSpecialList.length > 0) {
        this.styleList.map((item) => {
          e.customerSpecialList.map((citem) => {
            if (citem.desId == item.id) {
              item.chooseId = citem.specId;
            }
          });
        });
      } else {
        this.styleList.map((item) => {
          item.chooseId = item.details[0].id;
        });
      }
      if (
        this.specBodyParams.sizeType == 10053 &&
        this.cySizeList &&
        this.cySizeList.length > 0
      ) {
        this.clothing.map((item) => {
          this.cySizeList.map((cyitem) => {
            if (item.id == cyitem.clothId) {
              item.sizeList.map((sitem) => {
                this.$set(sitem, "inputValue", "");
                cyitem.partList.map((cypitem) => {
                  if (cypitem.partId == sitem.id) {
                    if (cypitem.partSize) {
                      this.$set(sitem, "inputValue", cypitem.partSize);
                    }
                    // if (this.customerDetails.heightUnit == 10266) {
                    // } else {
                    //   if (cypitem.partSize) {
                    //     sitem.inputValue = cmToInch(cypitem.partSize).toFixed(
                    //       2
                    //     );
                    //   } else {
                    //     sitem.inputValue = "";
                    //   }
                    // }
                    // sitem.inputValue = cypitem.partSize
                  }
                });
              });
            }
          });
        });
      } else {
        if (this.specBodyParams.sizeType !== 10054) {
          this.clothing.map((item) => {
            item.sizeList.map((sitem) => {
              this.$set(sitem, "inputValue", "");
            });
          });
        }
      }

      if (this.specBodyParams.sizeType != 10054) {
        if (e.customerSizeList.length > 0) {
          if (
            this.specBodyParams.sizeType == 10052 ||
            this.specBodyParams.sizeType == 10054
          ) {
            this.clothing.map((item) => {
              item.sizeList.map((sitem) => {
                this.$set(sitem, "inputValue", "");
                this.bodyList.map((bitem) => {
                  if (bitem.partId == sitem.id && bitem.partSize) {
                    sitem.inputValue = bitem.partSize;
                  }
                });
              });
            });
          }
        } else {
          this.clothing.map((item) => {
            item.sizeList.map((sitem) => {
              sitem.inputValue = "";
            });
          });
        }
      }

      this.submitOrder.customerId = e.id;
      this.submitOrder.customerName = e.custName;
      this.submitOrder.genderId = e.genderId;
      this.submitOrder.height = e.height;
      this.submitOrder.heightUnit = e.heightUnit;
      this.submitOrder.weight = e.weight;
      this.submitOrder.weightUnit = e.weightUnit;
      this.submitOrder.phone = e.phone;
      this.submitOrder.email = e.email;
      this.customerDetails = e;
      this.changeCusNum++;
      if (
        this.changeCusNum == 1 &&
        e.heightUnit == 10266 &&
        this.specBodyParams.sizeType != 10053
      ) {
        this.noChange = false;
      } else {
        this.noChange = true;
      }
    },
    // 获得品类
    async getCategory() {
      await this.getCategoryAction({
        orderWay: 7,
      }).then((res) => {
        // res.data.map((item) => {
        //   item.show = false;
        // });
        this.product = res.data;
        this.productId = Number(this.$route.query.id);
        // if(!this.productId){
        //   this.productId = res.data[0].id
        // }
        this.categoryMessage = res.data.filter((s) => {
          return this.$route.query.id == s.id;
        })[0];
        this.specBodyParams.category = this.productId;
        this.standard();
        this.getCraft(this.productId);
      });
    },
    // 选取面料
    changeFabri(e) {
      console.log("res", e);
    },
    // 搜索词改变时触发
    queryChangeFabri(e) {
      if (e.length === 0 || !this.submitOrder.fabric || !this.submitOrder.fabric.startsWith(e)) {
        this.zzFabricAction({
          clothCategory: this.productId,
          keywords: e,
        }).then((res) => {
          this.fabricListSearch = res.data;
          // this.fabricListSearch.push({
          //   fabricCode: e
          // });
        });
      }
    },
    handleKeydown(event) {
      console.log("Key pressed:", event.key);
      // 判断是否按下 Backspace 或 Delete 键
      if (event.key === "Backspace" || event.key === "Delete") {
        console.log("Delete key pressed. Clearing fabric...");
        this.submitOrder.fabric = null;
      }
    },
    // 获取单位
    getUnit() {
      this.getDictSystemAction({
        category: 10, //性别
      }).then((res) => {
        // console.log('res',res)
        this.genderList = res.data;
      });
      this.getDictSystemAction({
        category: 29, //体重
      }).then((res) => {
        this.weightList = res.data;
        if (this.needGetStyleInfo) {
          this.submitOrder.weightUnit = res.data[0].id;
        }
      });
      this.getDictSystemAction({
        category: 30, //身高
      }).then((res) => {
        res.data.map((item) => {
          if (item.id == 10266) {
            if (this.$route.query.orderId == undefined) {
              this.customerDetails = {
                heightUnitName: item.name,
                heightUnit: item.id,
              };
              this.submitOrder.heightUnit = item.id;
            }
          }
        });
        // console.log("this.customerDetails", this.customerDetails);
        this.heightList = res.data;
      });
    },
    // 修改身高
    changeHeight(item) {
      this.customerDetails.heightUnitName = item.label;
      this.customerDetails.heightUnit = item.value;
      // if (this.shapeCategory) {
      // this.measureInfo(this.shapeCategory);
      // }
    },
    changeStep(e) {
      // console.log(e);
      this.stepId = e.step;
      // console.log('stepId',this.stepId)
    },
    previous() {
      this.stepId--;
    },
    handleCreate1(val) {
      this.fabricListSearch.push({
        fabricCode: val,
      });
      // console.log("this.fabricListSearch", this.fabricListSearch);
    },
    // 第二步校验
    stepTwoCheck() {
      // 校验刺绣信息
      for (let i = 0; i < this.categroyMsg.length; i++) {
        let item = this.categroyMsg[i];
        // console.log(JSON.parse(JSON.stringify(item)));
        // 刺绣
        for (let s = 0; s < item.embList.length; s++) {
          let sitem = item.embList[s];
          if (sitem.site == "") {
            //位置
            this.$Message.error(
              sitem.siteName + " " + this.$t("quickorder.embSite")
            );
            return false;
          }
          if (sitem.color == "") {
            //颜色
            this.$Message.error(
              sitem.siteName + " " + this.$t("quickorder.embColor")
            );
            return false;
          }
          if (sitem.font == "") {
            //文字
            this.$Message.error(
              sitem.siteName + " " + this.$t("quickorder.embFont")
            );
            return false;
          }
          if (sitem.size == "" && this.showEmbSize) {
            //尺码
            this.$Message.error(
              sitem.siteName + " " + this.$t("quickorder.embSize")
            );
            return false;
          }
          if (sitem.content == "") {
            //内容
            this.$Message.error(
              sitem.siteName + " " + this.$t("quickorder.embContent")
            );
            return false;
          }
        }
        for (let s = 0; s < item.colorContrast.length; s++) {
          let sitem = item.colorContrast[s];
          for (let sc = 0; sc < sitem.children.length; sc++) {
            let scitem = sitem.children[sc];
            if (
              scitem.selectContrastList &&
              scitem.selectContrastList.length > 0 &&
              !scitem.selectContrastListFabric
            ) {
              this.$Message.error(
                sitem.name + " " + this.$t("quickorder.commoonNeed")
              );
              return false;
            }
            if (
              scitem.selectContrastList &&
              scitem.selectContrastList.length > 0 &&
              scitem.selectContrastListFabric &&
              scitem.selectContrastListFabric.sourceType == "TEXT" &&
              (scitem.selectContrastListFabric.value == undefined ||
                !scitem.selectContrastListFabric.value)
            ) {
              this.$Message.error(
                sitem.name + " " + this.$t("quickorder.commoonNeed")
              );
              return false;
            }
          }
        }
        for (let s = 0; s < item.craft.length; s++) {
          let msg = item.craft[s];
          if (msg.selectCraftList && msg.selectCraftList.length > 0) {
            // console.log("msg.selectCraftList", msg.selectCraftList);
            for (let s = 0; s < msg.selectCraftList.length; s++) {
              let child = msg.selectCraftList[s];
              if (
                child.sourceType == "TEXT" &&
                (child.value == "" || !child.value)
              ) {
                this.$Message.error(child.name + "not finished");
                return false;
              }
            }
          } else if (msg.selectCraft) {
            if (msg.sourceType == "TEXT" && (msg.value == "" || !child.value)) {
              this.$Message.error(msg.name + "not finished");
              return false;
            }
          }
        }
      }
    },
    // 第一步校验
    stepOneCheck() {
      // 校验客户信息
      if (this.submitOrder.customerName == "") {
        this.$Message.error(this.$t("quickorder.qcName"));
        return false;
      } else if (this.submitOrder.height == "") {
        this.$Message.error(this.$t("quickorder.qcHeight"));
        return false;
      }
      // if (this.submitOrder.weight == '') {
      //   this.$Message.error(this.$t("quickorder.qcWeight"));
      //   return false
      // }
      if (this.submitOrder.weightUnit == "") {
        this.$Message.error(this.$t("quickorder.qcWeightUnit"));
        return false;
      }
      if (this.submitOrder.genderId == "") {
        this.$Message.error(this.$t("quickorder.qcGender"));
        return false;
      }
      if (this.submitOrder.fabric == "") {
        this.$Message.error(this.$t("quickorder.qcFabric"));
        return false;
      }
      // if (this.submitOrder.inventory < 0) {
      //   this.$Message.error(this.$t("quickorder.qcFabricStock"));
      //   return false
      // }

      // 校验辅料信息
      for (let i = 0; i < this.categroyMsg.length; i++) {
        let item = this.categroyMsg[i];
        for (let s = 0; s < item.accessories.length; s++) {
          let sitem = item.accessories[s];
          // console.log(1734, sitem.selectCraft);
          if (
            sitem.selectCraft &&
            sitem.selectCraft.sourceType == "TEXT" &&
            (sitem.selectCraft.value == undefined || !sitem.selectCraft.value)
          ) {
            this.$Message.error(sitem.name + this.$t("quickorder.incomplete"));
            return false;
          }
        }
      }
      return true;
    },
    next() {
      if (this.stepId == 1 && this.stepOneCheck() == false) {
        //第一步校验
        return;
      } else if (this.stepId == 2 && this.stepTwoCheck() == false) {
        //第二步校验
        return;
      }
      // console.log("this.categroyMsg", this.categroyMsg);
      this.stepId++;
      if (this.stepId == 2) {
        this.chooseCraft(this.categroyMsg[0].craft[0]);
      }
      if (this.stepId == 3) {
        console.log(
          "standardChoose：",
          JSON.parse(JSON.stringify(this.standardChoose))
        );
        console.log(
          "tailoredList：",
          JSON.parse(JSON.stringify(this.tailoredList))
        );
        console.log(
          "garmentSize：",
          JSON.parse(JSON.stringify(this.garmentSize))
        );
        console.log(
          "customerDetails：",
          JSON.parse(JSON.stringify(this.customerDetails))
        );
        console.log(
          "standardList：",
          JSON.parse(JSON.stringify(this.standardList))
        );
        console.log("clothing：", JSON.parse(JSON.stringify(this.clothing)));
        console.log("editOnce：", JSON.parse(JSON.stringify(this.editOnce)));
        console.log(
          "categoryMessage：",
          JSON.parse(JSON.stringify(this.categoryMessage))
        );
        console.log("styleList：", JSON.parse(JSON.stringify(this.styleList)));
        console.log(
          "chooseStyleMsg：",
          JSON.parse(JSON.stringify(this.chooseStyleMsg))
        );
        console.log(
          "specBodyParams：",
          JSON.parse(JSON.stringify(this.specBodyParams.sizeType))
        );
        console.log("是否需要获取clothing", this.needGetStyleInfo);
        // if(this.needGetStyleInfo){
        this.getStyleInfo();
        // }
        this.listDictSystem();
      }
    },
    getStyleInfo() {
      this.styleInfoAction({
        category: this.specBodyParams.category,
      }).then((res) => {
        console.log(
          "this.needGetStyleInfo",
          this.clothing,
          this.needGetStyleInfo,
          this.clothing
        );
        if (this.needGetStyleInfo) {
          res.data.map((item) => {
            this.clothing.map((citem) => {
              if (citem.chooseStyleId == "") {
                citem.chooseStyleId = item.styleList[0].id;
              }
              if (item.id == citem.id) {
                citem.styleList = item.styleList;
              }
            });
          });
        }
        // this.clothing = res.data
      });
    },
    craftSelectSplice(e, changesMsg) {
      e.children.map((ccitem) => {
        if (
          changesMsg.craftChooseList.indexOf(ccitem.code) != -1 &&
          ccitem.isDefault == 0
        ) {
          changesMsg.craftChooseList.splice(
            changesMsg.craftChooseList.indexOf(ccitem.code),
            1
          );
          if (ccitem.children && ccitem.children.length > 0) {
            this.craftSelectSplice(ccitem, changesMsg);
          }
        }
      });
    },
    async craftSelectSpliceCopy(e) {
      await this.categroyMsg.map((item) => {
        if (item.id == e.code.split("_")[0]) {
          let changesMsg = "";
          changesMsg = item;
          e.copyChildren.map((ccitem) => {
            // console.log('ccitem',ccitem,item)
            if (
              changesMsg.craftChooseList.indexOf(ccitem.code) != -1 &&
              ccitem.isDefault == 0
            ) {
              changesMsg.craftChooseList.splice(
                changesMsg.craftChooseList.indexOf(ccitem.code),
                1
              );
              // 暂时不考虑无限下级情况
              // if (ccitem.children && ccitem.children.length > 0) {
              //   this.craftSelectSpliceCopy(ccitem, changesMsg);
              // }
            }
          });
        }
      });
    },
    // 搜索工艺 赋值替换原工艺
    searchCraft(e, params) {
      // 如果不存在列表
      // if (e.length == 0) {
      //   return;
      // }
      // let params = {
      //   category: "",
      //   craftIds: "",
      // };
      this.getSelectCraft(params);
      // console.log('e',params)
      // let params = {
      //   category: e[0].split("_")[0],
      //   craftIds: "",
      // };
      // 使用切换时的默认值
      // e.map((item) => {
      //   item.split("_").map((citem, cindex) => {
      //     if (cindex > 0) {
      //       if (citem) {
      //         params.craftIds = params.craftIds + citem + ",";
      //       }
      //     }
      //   });
      // });
      // let arrFrom = Array.from(new Set(params.craftIds.split(",")));
      // params.craftIds = arrFrom.join(",");
      let changeList = [];
      let changeChildIdsList = [];
      // console.log('params',params,e)
      if (!params.craftIds) {
        return;
      }
      this.searchCraftAction(params).then((res) => {
        this.replaceCraft = res.data;
        if (res.data.length > 0) {
          res.data.map((item) => {
            if (item.children && item.children.length > 0) {
              this.setParentIds(item);
            }
            changeList.push(item.code);
            changeChildIdsList.push(item.childIds);
            // 避免默认赋值不显示
            let change = true;
            let children = JSON.parse(JSON.stringify(item.children));
            for (let i = 0; i < item.children.length; i++) {
              if (
                params.craftIds
                  .split(",")
                  .indexOf(item.children[i].id.toString()) > -1
              ) {
                this.$set(item.children[i], "isDefault", 1);
                change = false;
              } else {
                this.$set(item.children[i], "isDefault", 0);
              }
            }
            if (change) {
              item.children = JSON.parse(JSON.stringify(children));
            }
          });
        }
        // console.log("changeList", changeList, changeChildIdsList);
        this.categroyMsg.map((item) => {
          item.craft.map((citem) => {
            // 检查当前选中列表是否存在下级
            // console.log('citem.childIds',citem.childIds)
            if (changeList.indexOf(citem.code) != -1) {
              if (changeChildIdsList.indexOf(citem.childIds) == -1) {
                /*替换*/
                if (!citem.copyChildren || citem.copyChildren.length == 0) {
                  citem.children.map((pitem) => {
                    pitem.isDefault = 0;
                  });
                  citem.copyChildren = JSON.parse(
                    JSON.stringify(citem.children)
                  );
                }
                citem.childIds =
                  this.replaceCraft[changeList.indexOf(citem.code)].childIds;
                citem.children =
                  this.replaceCraft[changeList.indexOf(citem.code)].children;
                /*替换之前查看是否有已选中属性 置空*/

                this.craftSelectSpliceCopy(citem).then(() => {
                  // console.log('替换的数据',citem.children,citem)
                  for (let i = 0; i < citem.children.length; i++) {
                    let changeItem = citem.children[i];
                    if (changeItem.isDefault == 1) {
                      citem.selectCraft = changeItem;
                    }
                  }
                  // citem.children.map(changeItem=>{
                  //   if(changeItem.isDefault==1){
                  //     console.log('changeItem',changeItem.isDefault,changeItem)
                  //     citem.selectCraft = changeItem
                  //   }
                  // })
                });
              }
            } else {
              if (citem.copyChildren && citem.copyChildren.length > 0) {
                citem.children = JSON.parse(JSON.stringify(citem.copyChildren));
              }
              citem.copyChildren = [];
            }
            if (citem.children && citem.children.length > 0) {
              this.replaceChildren(
                citem.children,
                changeList,
                changeChildIdsList
              );
            }
          });
        });
      });
    },

    // 获取选中工艺
    getSelectCraft(params) {
      // params.craftIds
      // console.log("this.categroyMsg", this.categroyMsg);
      for (let i = 0; i < this.categroyMsg.length; i++) {
        let item = this.categroyMsg[i];
        for (let s = 0; s < item.craft.length; s++) {
          let craftMsg = item.craft[s];
          if (craftMsg.selectCraft) {
            params.craftIds = params.craftIds + craftMsg.selectCraft.id + ",";
            params.craftIds =
              params.craftIds + craftMsg.selectCraft.parentId + ",";
          }
          if (craftMsg.selectCraftList && craftMsg.selectCraftList.length > 0) {
            for (let cr = 0; cr < craftMsg.selectCraftList.length; cr++) {
              let crMsg = craftMsg.selectCraftList[cr];
              params.craftIds = params.craftIds + crMsg.id + ",";
              params.craftIds = params.craftIds + crMsg.parentId + ",";
            }
          }
        }
      }
    },
    //**提交部分 */
    //**  特体信息赋值
    setSpecialBody() {
      this.submitOrder.bodyTypeList = [];
      this.styleList.map((item) => {
        if (item.chooseId) {
          this.submitOrder.bodyTypeList.push(item.chooseId);
        }
      });
    },
    //**  尺寸赋值
    setSize(cloItem, detailsMsg, type) {
      let {sizeList} = cloItem;
      let {sizeCategoryId} = this.submitOrder;
      let {standardChoose} = this;

      // 校验逻辑
      const validateSizeList = (sizeList) => {
        for (const {
          disabled,
          isMust,
          inputValue,
          name,
          maxValue,
          minValue,
        } of sizeList) {
          if (!disabled && isMust === 1 && !inputValue) {
            this.$Message.error(`${name} ${this.$t("newOrder.cannotEmpty")}`);
            return false;
          }
          if (
            !disabled &&
            inputValue &&
            (inputValue > maxValue || inputValue < minValue)
          ) {
            this.$Message.error(`${name} ${this.$t("newOrder.scope")}`);
            return false;
          }
        }
        return true;
      };

      // 如果校验失败，提前返回
      if (!validateSizeList(sizeList)) return false;

      // 重置 detailsMsg 对象
      Object.assign(detailsMsg, {shape: "", sizeList: [], styleId: ""});

      // 根据不同的 sizeCategoryId 设置不同的属性
      if (sizeCategoryId === 10054) {
        detailsMsg.shape = cloItem.chosoeId;
      } else if (sizeCategoryId === 10052) {
        detailsMsg.styleId = cloItem.chooseStyleId;
      }

      // 遍历 sizeList，并生成 detailsMsg.sizeList
      sizeList.forEach(
        ({disabled, finishId, inputValue, id, defaultValue, finishValue}) => {
          if (disabled) return;

          if (sizeCategoryId === 10052 && finishId && type !== "size") {
            detailsMsg.sizeList.push({
              partValue: finishValue,
              partId: finishId,
            });
          }

          detailsMsg.sizeList.push({
            partValue: inputValue,
            partId: id,
            modifyValue:
              standardChoose === "size" ? inputValue - defaultValue : "",
          });
        }
      );

      return true;
    },
    // 工艺赋值
    setCraftMap(crafChildren, detailsMsg) {
      crafChildren.map((s) => {
        // if (s.selectCraft) {
        //   detailsMsg.craftList.push({
        //     craftId: s.selectCraft.id,
        //     content: s.selectCraft.value ? s.selectCraft.value : "",
        //   });
        // }
        if (s.selectCraftList && s.selectCraftList.length > 0) {
          s.selectCraftList.map((m) => {
            detailsMsg.craftList.push({
              craftId: m.id,
              content: m.value ? m.value : "",
            });
          });
        }
      });
    },
    //**撞色赋值
    setColorContrast(contrastItem, detailsMsg) {
      // console.log("撞色", contrastItem);
      contrastItem.children.map((zs) => {
        if (zs.selectContrastList && zs.selectContrastList.length > 0) {
          zs.selectContrastList.map((zsc) => {
            detailsMsg.contrastSaveList.push({
              site: zsc.id,
              color: zs.selectContrastListFabric.id,
              content: zs.selectContrastListFabric.value,
            });
          });
        }
      });
      // if (contrastItem.chooseFabric && contrastItem.check) {
      //   //选中并存在选择撞色面料
      //   detailsMsg.contrastSaveList.push({
      //     color: contrastItem.chooseFabric,
      //     site: contrastItem.id,
      //   });
      // }
    },
    // 辅料
    setFlMap(crafChildren, detailsMsg) {
      // console.log("crafChildren", crafChildren);
      crafChildren.map((s) => {
        if (s.selectCraft) {
          detailsMsg.craftList.push({
            craftId: s.selectCraft.id,
            content: s.selectCraft.value ? s.selectCraft.value : "",
          });
        }
      });
    },
    // 刺绣赋值  刺绣有些数据输入为空时 给提示
    setEmbs(cateItem, detailsMsg) {
      detailsMsg.embList = cateItem.embList;

      // cateItem.emb.map((embItem, embIndex) => {
      //   if (embItem.check) {
      //     embItem.embContent.site = embItem.id;
      //     embItem.embContent.href = embItem.href;
      //     embItem.embContent.file = embItem.file;
      //     detailsMsg.embList.push(embItem.embContent);
      //     if (this.$route.query.orderId) {
      //       if (embItem.file) {
      //         this.$set(embItem.embContent, "sourceType", "edit");
      //       }
      //     } else {
      //       if (embItem.file) {
      //         this.$set(embItem.embContent, "sourceType", "add");
      //       }
      //     }
      //   }
      // });
    },
    preSubmit() {
      this.submit("size");
    },
    // 获取接口返回数据中有用的部分
    handleGetReturnDatat(data) {
      let returnData = {};
      Object.keys(data).map((key) => {
        returnData = data[key];
      });
      return returnData;
    },
    // 预提交
    async submitPre() {
      await this.getFinishedSizeAction(this.submitOrder)
        .then((res) => {
          if (res.code === 0) {
            for (let key in res.data) {
              let item = this.clothing.find((item) => item.id == key);
              item.sizeList.map((s) => {
                let size = res.data[key].find((i) => i.refPartId == s.id);
                if (undefined !== size) {
                  this.$set(s, "finishValue", size.partValue);
                  this.$set(s, "finishId", size.partId);
                }
              });
            }
            this.isPreSubmit = true;
          } else {
            this.$Message.error(res.message);
          }
        })
        .finally((res) => {
          this.spinShow = false;
        });
    },
    // 提交购物车
    submitCart() {
      this.saveOrderAction(this.submitOrder)
        .then((res) => {
          // cons.log("是否保存成功", res);
          if (res.code == 0) {
            this.$Message.success(res.message);
            if (
              this.$route.query.orderType &&
              this.$route.query.orderType === "pending"
            ) {
              this.$router.push("./myOrder");
            } else {
              this.$router.push("./saveItems");
            }
          } else {
            this.$Message.error(res.message);
          }
        })
        .finally((res) => {
          this.spinShow = false;
        });
    },
    // 提交购物车
    submitOrderFun() {
      this.submitOrderAction(this.submitOrder)
        .then((res) => {
          // cons.log("是否保存成功", res);
          if (res.code == "0") {
            let returnData = this.handleGetReturnDatat(res.data);
            this.$Message.success(res.message);
            if (returnData.sign && returnData.sign === "fail") {
              this.$router.push("/myOrder");
            } else {
              this.$router.push("/underProduction");
            }
          } else {
            this.$Message.error(res.message);
          }
        })
        .finally((res) => {
          this.spinShow = false;
        });
    },
    // 提交
    submit(type) {
      this.submitOrder.clothCategory = this.productId;

      // 设置面料
      // if (this.iptFabric) {
      //   //如果是输入的CTM面料
      //   this.submitOrder.fabric = this.iptFabric;
      // } else {
      //   //没有输入 普通选中面料
      //   this.fabricList.map((item) => {
      //     if (item.check) {
      //       this.submitOrder.fabric = item.fabricCode;
      //     }
      //   });
      // }
      // 面料为空提示
      // if (this.submitOrder.fabric == "") {
      //   this.$Message.error(this.$t("newOrder.fabricRequired"));
      //   return;
      // }
      this.submitOrder.detailList = []; //分步工艺置空
      this.categroyMsg.map((cateItem, cateIndex) => {
        // 循环当前工艺
        this.submitOrder.detailList.push(
          JSON.parse(JSON.stringify(this.detailList))
        );
        let detailsMsg = this.submitOrder.detailList[cateIndex];
        //**  赋值当前品类id
        console.log("sss", cateItem);
        detailsMsg.clothCategory = cateItem.id;
        //**  赋值当前选中的的工艺信息
        // cateItem.craftList.map((craftItem, craftIndex) => {
        //   // 如果当前工艺如果不是撞色跟刺绣 循环
        //   if (craftItem.category == 1 || craftItem.category == 3) {
        //     // detailsMsg.craftMap.description
        //     this.setCraftMap(craftItem.children, detailsMsg);
        //   }
        // });
        // 工艺
        this.setCraftMap(cateItem.craft, detailsMsg);
        // 辅料
        this.setFlMap(cateItem.accessories, detailsMsg);
        if (cateItem.colorContrast && cateItem.colorContrast.length > 0) {
          //如果是撞色
          cateItem.colorContrast.map((contrastItem) => {
            this.setColorContrast(contrastItem, detailsMsg);
          });
        }
        //**赋值选中的刺绣 */
        this.setEmbs(cateItem, detailsMsg);
      });

      let customerPass = true;
      //如果赋值成功
      if (customerPass) {
        //**客户单号赋值 */
        // this.submitOrder.cusOrderCode = this.params.orderMsg.inputValue;
        //**尺寸分类赋值*/
        this.submitOrder.sizeCategoryId = this.specBodyParams.sizeType;
        //**赋值特体信息 */
        this.setSpecialBody();
        if (this.submitOrder.sizeCategoryId === 10054) {
          //标准号 选职责号型大类
          this.submitOrder.sizeAreaId = this.standardChoose.id;
        } else {
          this.submitOrder.sizeAreaId = "";
        }
        //**  尺寸赋值
        let passSize = true;
        for (let i = 0; i < this.clothing.length; i++) {
          let detailsMsg = this.submitOrder.detailList[i];
          passSize = this.setSize(this.clothing[i], detailsMsg, type);
          if (passSize == false) {
            break;
          }
        }
        if (passSize) {
          if (
            this.$route.query.orderId &&
            this.$route.query.orderType !== "buyagain"
          ) {
            this.submitOrder.orderId = this.$route.query.orderId;
          }

          // let custInfo = {
          //   basicList: this.basicList,
          // };
          // this.submitOrder.custInfo = JSON.stringify(custInfo);
          let orderInfo = {
            fabricList: this.fabricList,
            categroyMsg: this.categroyMsg,
            params: this.params,
            standardChoose: this.standardChoose,
            styleList: this.styleList,
            clothing: this.clothing,
            isAddShow: this.isAddShow,
            basicList: this.basicList,
            specBodyParams: this.specBodyParams,
          };
          this.submitOrder.orderInfo = JSON.stringify(orderInfo);
          this.spinShow = true;
          // return
          if (type == "size") {
            //如果只是为了号型
            this.submitPre();
          } else if (type == "order") {
            if (
              this.isPreSubmit == false &&
              this.submitOrder.sizeCategoryId === 10052
            ) {
              this.submitPre().then(() => {
                this.submitOrderFun();
              });
            } else {
              this.submitOrderFun();
            }
          } else {
            //提交订单
            this.submitCart();
          }
        }
      }
    },
    previewItemImg(item) {
      if (item && item.imgPath) {
        const $viewer = viewerApi({
          options: {
            toolbar: true,
            navbar: false,
            title: false,
            movable: true,
            zoomable: true,
          },
          images: [item.imgPath],
        });
      }
    },
    // 初始化刺绣项
    initEmbItem(embItem) {
      if (this.showEmb && this.showEmb.emb && embItem.site) {
        const selectedItem = this.showEmb.emb.find(item => item.id === embItem.site);
        if (selectedItem) {
          embItem.siteName = selectedItem.name;
          embItem._initialized = true;
          this.$forceUpdate();
        }
      }
    },
    // 处理默认工艺冲突
    handleDefaultCraftConflicts() {
      if (!this.categroyMsg || this.categroyMsg.length === 0) return;
      
      // 遍历所有分类
      this.categroyMsg.forEach(category => {
        // 处理工艺
        if (category.craft && category.craft.length > 0) {
          category.craft.forEach(craftGroup => {
            this.resolveDefaultConflictInGroup(craftGroup);
          });
        }
        
        // 处理辅料
        if (category.accessories && category.accessories.length > 0) {
          category.accessories.forEach(accessory => {
            if (accessory.children) {
              this.resolveDefaultConflictInGroup(accessory);
            }
          });
        }
        
        // 处理撞色
        if (category.colorContrast && category.colorContrast.length > 0) {
          category.colorContrast.forEach(contrast => {
            if (contrast.children) {
              contrast.children.forEach(contrastGroup => {
                this.resolveDefaultConflictInGroup(contrastGroup);
              });
            }
          });
        }
      });
    },

    // 解决组内默认选中冲突
    resolveDefaultConflictInGroup(group) {
      if (!group.children || group.children.length === 0) return;
      
      // 单选模式下确保只有一个默认选中项
      if (group.chooseType !== 'CHECKBOX') {
        const defaultItems = group.children.filter(item => item.isDefault === 1);
        
        // 如果有多个默认项，只保留第一个
        if (defaultItems.length > 1) {
          defaultItems.forEach((item, index) => {
            if (index > 0) {
              this.$set(item, 'isDefault', 0);
              this.$set(item, 'select', false);
            }
          });
        }
      }
      
      // 递归处理子级
      group.children.forEach(child => {
        if (child.children && child.children.length > 0) {
          this.resolveDefaultConflictInGroup(child);
        }
      });
    },
    // 更新工艺预览显示
    updateCraftPreview(craftItem) {
      if (!craftItem) return;
      
      // 初始化选择列表（如果不存在）
      if (!craftItem.selectCraftList) {
        this.$set(craftItem, "selectCraftList", []);
      }
      
      // 找出所有选中的项目
      const findSelectedItems = (children) => {
        if (!children) return [];
        
        let selected = [];
        children.forEach(child => {
          if (child.select === true || child.isDefault === 1) {
            selected.push(child);
          }
          
          if (child.children && child.children.length > 0) {
            const childSelected = findSelectedItems(child.children);
            selected = selected.concat(childSelected);
          }
        });
        
        return selected;
      };
      
      // 更新选择列表 - 使用新数组避免引用问题
      const selectedItems = findSelectedItems(craftItem.children);
      
      // 去重，确保每个ID只出现一次
      const uniqueItems = [];
      selectedItems.forEach(item => {
        if (!uniqueItems.some(existing => existing.id === item.id)) {
          uniqueItems.push(item);
        }
      });
      
      craftItem.selectCraftList = uniqueItems;
      
      // 如果是单选模式，设置selectCraft
      if (craftItem.chooseType === "RADIO" && uniqueItems.length > 0) {
        craftItem.selectCraft = uniqueItems[0];
      }
    },
  },
};
</script>
<style scoped lang="less">
// .autoComplete-select{
//   border-radius: 4px;
//   border: 1px solid #dcdee2;
// }
// .autoComplete-select-box{
//   /deep/.ivu-input{
//     border: none;
//   }
// }
.ivu-icon-select {
  /deep/ .ivu-icon-ios-arrow-down {
    display: none;
  }
}

.option-with-image {
  width: 100%;
  display: flex;
  align-items: center;
  
  .fabric-item {
    display: flex;
    align-items: center;
    cursor: default;
  }
}

/deep/ .ivu-select-dropdown {
  z-index: 1000;
  max-height: 200px;
}

/deep/ .ivu-tooltip {
  z-index: 1001;
}

/deep/ .ivu-input-default {
  // border: none;
  background: #f8f8f8;
}

.measurement-method {
  /deep/ .ivu-select-selection {
    background: #f8f8f8;
    border: none;
  }
}

.order-l-item-selects {
  background: #e6edf9;
}

.measurement-item {
  width: 225px;
  height: 52px;
  background: #f8f8f8;
  margin-bottom: 5px;
  padding: 0 20px;

  .measurement-item-label {
    font-size: 14px;
    font-weight: 400;
    color: #081938;
    line-height: 16px;
    width: 80px;
  }

  .measurement-item-ipt {
    /deep/ .ivu-input {
      background: #f8f8f8;
      border: none;
      box-shadow: none;
    }
  }
}

.style-name {
  font-size: 16px;
  font-weight: 500;
  color: #081938;
  line-height: 19px;
  margin: 16px 0;
}

.style-w-label {
  width: 144px;
  height: 32px;
  font-size: 14px;
  font-weight: 400;
  color: #000000;
  line-height: 16px;
  margin-right: 10px;
}

.style-w-items {
  width: 144px;
  height: 32px;
  background: #f8f8f8;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 400;
  color: #081938;
  line-height: 32px;
  text-align: center;
  margin-bottom: 10px;
}

.style-w-items-select {
  background: #0a4dcc;
  color: #ffffff;
}

.measurement-method-unit {
  font-size: 14px;
  font-weight: 400;
  color: #081938;
  line-height: 20px;
  text-align: right;
  margin: 9px 0;
  padding-right: 40px;
}

.categroy-name {
  font-size: 14px;
  font-weight: 500;
  text-align: left;
  color: #0a4dcc;
  line-height: 16px;
  margin-bottom: 10px;
  margin-top: 10px;
}

.quick-order-details {
  width: 1420px;
  margin: 10px auto 0;
  background: #fff;
  padding: 10px 40px 10px;
  text-align: left;
  // min-height: 1000px;
  height: calc(100vh - 104px);
  position: relative;

  // position: ;
  .quick-order-l-box {
    width: 430px;
    height: calc(100vh - 104px);
    background: #fff;
  }

  .quick-order-l {
    width: 420px;
    height: calc(100vh - 104px);
    // overflow-y: auto;
    // overflow-x: hidden;
    position: sticky;
    // top: 104px;
  }

  .quick-order-r {
    flex: 1;
    padding-left: 40px;
    height: calc(100vh - 104px);

    .order-r-optional {
      font-size: 16px;
      font-weight: 500;
      color: #081938;
      line-height: 19px;
    }

    .order-r-box {
      margin-bottom: 20px;
    }

    .order-r-title {
      margin-right: 24px;
      width: 60px;
    }

    .order-r-ipt {
      width: 350px;
    }

    .order-r-textarea {
      /deep/ .ivu-input {
        background-color: #f8f8f8;
        // border:none
      }
    }

    .craft-item-box {
      margin-right: 17px;
      margin-bottom: 10px;
    }

    .craft-item-box-small {
      margin-right: 30px;
      margin-bottom: 10px;
    }

    .craft-item {
      .craft-item-i-box {
        width: 156px;
        height: 156px;
        border-radius: 2px;
        border: 2px solid #fff;
        background: #f8f8f8;

        .craft-item-i-box-big {
          width: 152px;
          height: 152px;
        }
      }

      .craft-item-name {
        font-size: 12px;
        font-weight: 400;
        color: #081938;
        line-height: 14px;
        text-align: center;
        margin-top: 10px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        width: 100px;
      }

      .craft-item-select {
        border: 2px solid #003888;
        position: relative;

        .craft-item-price {
          width: 151px;
          height: 18px;
          line-height: 18px;
          background: #0a4dcc;
          border-radius: 2px;
          position: absolute;
          left: 0;
          right: 0;
          margin-right: auto;
          margin-left: auto;
          bottom: 2px;
          text-align: center;
          color: #fff;
          font-size: 12px;
        }
      }
    }

    .craft-item-i-box {
      width: 156px;
      height: 156px;
      border-radius: 2px;
      border: 2px solid #fff;
      background: #f8f8f8;

      .craft-item-i-box-big {
        width: 152px;
        height: 152px;
      }
    }

    .craft-item-name {
      font-size: 12px;
      font-weight: 400;
      color: #081938;
      line-height: 14px;
      text-align: center;
      margin-top: 10px;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
      width: 100px;
    }

    .craft-item-select {
      border: 2px solid #003888;
      position: relative;

      .craft-item-price {
        width: 151px;
        height: 18px;
        line-height: 18px;
        background: #0a4dcc;
        border-radius: 2px;
        position: absolute;
        left: 0;
        right: 0;
        margin-right: auto;
        margin-left: auto;
        bottom: 2px;
        text-align: center;
        color: #fff;
        font-size: 12px;
      }
    }

    .craft-optional {
      font-size: 14px;
      font-family: ArialMT;
      color: #081938;
      line-height: 16px;
      margin-bottom: 15px;
    }

    .craft-item-btns {
      padding-bottom: 20px;
      margin-bottom: 20px;
      // border-bottom: 1px solid rgba(8, 25, 56, 0.3);
    }

    .craft-set-price {
      width: 300px;
      height: 40px;
      background: #ffffff;
      border-radius: 4px;
      border: 1px solid rgba(8, 25, 56, 0.1);
      padding: 0 7px;
      margin-bottom: 20px;

      /deep/ .ivu-input {
        border: none;
        box-shadow: none;
      }

      .craft-price {
        width: 74px;
        height: 22px;
        background: #0a4dcc;
        border-radius: 2px;
        font-size: 12px;
        font-weight: 400;
        color: #ffffff;
        line-height: 22px;
        text-align: center;
      }
    }

    .craft-item-small {
      .craft-item-i-box {
        width: 100px;
        height: 100px;
        border-radius: 2px;
        border: 2px solid #fff;
        background: #fff;

        img {
          display: block;
          margin: 0 auto;
          max-width: 96px;
          object-fit: cover;
        }
      }

      .craft-item-name {
        font-size: 12px;
        font-weight: 400;
        color: #081938;
        line-height: 14px;
        text-align: center;
        margin-top: 10px;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
        width: 100px;
      }

      .craft-item-select {
        border: 2px solid #003888;
        position: relative;
        overflow: hidden;

        .craft-item-price {
          width: 94px;
          height: 18px;
          line-height: 18px;
          background: #0a4dcc;
          border-radius: 2px;
          position: absolute;
          left: 0;
          right: 0;
          margin-right: auto;
          margin-left: auto;
          bottom: 2px;
          text-align: center;
          color: #fff;
          font-size: 12px;
        }
      }
    }

    .emb-title {
      font-size: 14px;
      color: #081938;
      line-height: 16px;
      margin-bottom: 20px;
    }

    .emb-item {
      margin-right: 40px;
    }

    .md-add {
      width: 40px;
      height: 40px;
      background: #0a4dcc;
      border-radius: 4px;
      color: #fff;
      font-weight: bold;
      margin-left: 40px;
      padding: 0;
      text-align: center;
      line-height: 40px;
    }
  }
}

.craft-from-box {
  margin-top: 20px;
}

.craft-from-box-bottom {
  margin-top: 0px;
  margin-bottom: 20px;
}

.craft-from {
  width: 90px;
}

.order-l-item {
  width: 420px;
  // min-height: 52px;
  // padding: 12px 0;
  background: #f8f8f8;
  margin: 5px 0;
  padding: 12px 30px;

  .order-l-item-label {
    font-size: 14px;
    font-weight: 400;
    color: #081938;
    line-height: 16px;
    // margin-right: 33px;
    width: 70px;
    padding-right: 10px;
    text-align: left;
    position: relative;
  }

  .order-l-item-label-icon {
    position: absolute;
    left: -20px;
    font-size: 16px;
    cursor: pointer;
    top: 0;
    bottom: 0;
    margin-top: auto;
    margin-bottom: auto;
  }

  .order-l-item-label-icon:hover {
    // opacity: .7;
  }

  /deep/ .ivu-select-selection {
    border: none;
    background-color: #f8f8f8 !important;
  }

  .order-l-item-ipt {
    background-color: #f8f8f8 !important;
    width: 200px;

    /deep/ .ivu-input {
      border: none;
      box-shadow: none;
      background-color: #f8f8f8 !important;
    }
  }

  .order-l-item-craft {
    width: 120px;
    margin-right: 20px;
  }

  .order-l-item-select {
    flex: 1;
    font-size: 14px;
    font-weight: 500;
    color: #081938;
    line-height: 16px;
  }
}

.craft-item-b-title {
  height: 16px;
  font-size: 14px;
  font-family: ArialMT;
  color: #081938;
  line-height: 16px;
  margin-bottom: 20px;
  font-weight: bold;
}

.order-l-item-selects {
  background: #e6edf9;
}

.quick-order {
  position: relative;
}

.quick-order-step {
  width: 100%;
  min-width: 1440px;
  height: 24px;
  background: #0a4dcc;
  overflow: hidden;

  .new-order-select {
    margin: 0 37px 0 0;
  }

  /deep/ .ivu-icon {
    color: #0a4dcc;
  }

  /deep/ .ivu-select-single .ivu-select-selection {
    height: 22px;
  }

  /deep/ .ivu-select-input {
    height: 22px;
  }

  /deep/ .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
    line-height: 18px;
    color: #0a4dcc;
  }

  .step-item {
    color: #fff;
    font-size: 14px;

    .step-item-name {
      position: relative;
    }

    .step-item-choose {
      position: absolute;
      width: 0;
      height: 0;
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      border-bottom: 4px solid #fff;
      bottom: -2px;
      left: 0;
      right: 0;
      margin-left: auto;
      margin-right: auto;
    }
  }
}

.contrast-p-name {
  padding: 0 10px;
  height: 34px;
  background: #f8f8f8;
  color: #979eaa;
  border: 1px solid #f8f8f8;
  cursor: pointer;
  line-height: 34px;
  text-align: center;
  font-size: 12px;
  position: relative;
  margin-bottom: 5px;
  margin-right: 30px;
  // box-sizing: border-box;
  min-width: 100px;
}

.contrast-p-name-select {
  border: 1px solid #0a4dcc;
  background: rgb(230, 237, 249);
  color: rgb(10, 77, 204);
}

.quick-line {
  margin-top: 10px;
  margin-bottom: 10px;
  height: 1px;
  opacity: 0.3;
  border-bottom: 1px solid #081938;
}

// .dress-style {
//     padding: 30px 60px 30px 40px;
//     width: 1440px;
//     background: #fff;
//     margin: 0 auto 8px;
//     .dress-style-title {
//       font-size: 14px;
//       font-family: Roboto;
//       font-weight: 700;
//       text-align: left;
//       color: #000000;
//       line-height: 16px;
//       margin-bottom: 20px;
//     }
.dress-img {
  width: 198px;
  // height: 374px;
  background: #f8f8f8;
  border-radius: 6px;
  margin-left: 20px;
  height: 100%;

  > img {
    width: 198px;
  }

  > div {
    font-size: 12px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    text-align: center;
    color: #666666;
    line-height: 17px;
    padding: 8px;
  }
}

//   }
//   .measurements {
//     width: 1440px;
//     padding: 30px 40px 40px;
//     background: #fff;
//     margin: 0 auto;
//     .finished-measurements {
//       font-size: 12px;
//       font-family: Roboto;
//       font-weight: 700;
//       text-decoration: underline;
//       text-align: center;
//       color: #1e64d2;
//       line-height: 14px;
//     }
//     .measurements-title {
//       font-size: 16px;
//       font-family: Arial;
//       font-weight: bold;
//       text-align: left;
//       color: #000000;
//       line-height: 18px;
//       margin-bottom: 20px;
//     }
//   }
.quick-btns {
  position: fixed;
  width: 300px;
  right: calc((140vw - 1360px) / 2);
  // right: 0;
  // margin-left: auto;
  // margin-right: auto;
  height: 40px;
  bottom: 20px;

  Button {
    background: #0a4dcc;
    color: #fff;
  }
}

/* 一开始隐藏 */

.common-rowUnder-hide::-webkit-scrollbar {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/quickOrder/quickOrder.vue